//Use the URL to bypass CORS issue : -
import axios from 'axios';
import { setTeamDetails, updateAssistantName } from '../common/common_action';
import report from '../project/report/report';
import {
  GET_JIRA_CHANNELS,
  GET_JIRA_PROJECTS,
  ADD_JIRA_PROJECTS,
  GET_JIRA_BOARDS,
  GET_JIRA_ISSUES,
  SET_DEFAULT_JIRA_PERSONAL_CHANNEL,
  SET_SKILL_DATA,
  SET_DEFAULT_JIRA_CHANNEL,
  PERSONAL_JIRA_SETTING,
  SET_CURRENT_SKILL_USER,
  GET_JIRA_NOTIFICATION_CONFIGURATION,
  SET_JIRA_NOTIFICATION_CONFIGURATION,
  GET_JIRA_USER_NOTIFICATION_CONFIGURATION,
  SET_JIRA_USER_NOTIFICATION_CONFIGURATION,
  SET_WORKSPACE_ASSISTANT_SKILLS,
  UPDATE_ASSISTANT_SKILLS,
  SET_SLACK_LINK,
  SET_SLACK_CHANNELS,
  GET_CHANNEL_DATA,
  GET_SKILL,
  EMAIL_SUBSCRIPTION,
  SET_JIRA_BOARD_SPRINTS,
  SET_CURRENT_SKILL,
  SET_CURRENT_TEAMSYNC,
  DELETE_USER_TEAMSYNC,
  //standups:my standups
  SET_USER_TEAMSYNC,
  SET_USER_TEAMSYNCS,
  //standups:show reports
  SET_TEAM_SYNC_INSTANCE,
  SET_PROJECT_PROGRESS_REPORTS,
  PREV_NXT_INSTANCE_NOT_AVAILABLE,
  PREV_INSTANCE_NOT_AVAILABLE,
  NXT_INSTANCE_NOT_AVAILABLE,
  PREV_NXT_INSTANCE_AVAILABLE,
  GET_INSTANCE_EMPTY,
  SET_TEAM_SYNC_INSTANCE_RESPONSE,
  GET_USERMAPPING_USERS,
  SET_JIRA_USERS,
  SET_LOADING,
  ADD_USER_MAPPING,
  // standups : Resume now
  UPDATE_USER_TEAMSYNCS,
  SET_ALERT,
  REMOVE_ALERT,
  SET_WORKSPACE_MEMBERS,
  ADD_WORKSPACE_MEMBER,
  SET_USER,
  SET_WORKSPACE,
  LEAVE_WORKSPACE,
  DELETE_WORKSPACE_MEMBER,
  UPDATE_WORKSPACE_MEMBERSHIP,
  DELETE_USER_MAPPING,
  EDIT_USER_MAPPING,
  GET_JIRA_STATUSES,
  UPDATE_TEAMSYNC_INSTANCE_REPORT,
  SET_CONFULENCE_SPACES,
  SET_CONFULENCE_CHANNEL_CONFIG,
  SET_CONFULENCE_CHANNEL_CONFIG_LIST,
  ADD_CONFLUENCE_CHANNEL_CONFIG,
  REMOVE_CONFLUENCE_CHANNEL_CONFIG,
  ADD_CHANNEL,
  RECENT_REMINDERS,
  APP_HOME_CONFIG,
  SET_BOT_CHANNEL,
  SET_BOT_USERS,
  GET_BOT_INVITED_SLACK_CHANNELS,
} from './types';

export function setAssisantSkills(skills) {
  return {
    type: SET_WORKSPACE_ASSISTANT_SKILLS,
    skills,
  };
}
export function reRender(isReRender) {
  return {
    type: 'SET_ReRender',
    isReRender,
  };
}

export function updateAssisantSkills(skill) {
  return {
    type: UPDATE_ASSISTANT_SKILLS,
    skill,
  };
}

export function getChannel(channels) {
  return {
    type: GET_JIRA_CHANNELS,
    channels,
  };
}

export function getInvitedChannel(channels) {
  return {
    type: GET_BOT_INVITED_SLACK_CHANNELS,
    channels,
  };
}

export function updateChannel(channels) {
  return {
    type: 'UPDATE_SLACK_CHANNELS',
    channels,
  };
}

export function setBotChannel(channel) {
  return {
    type: SET_BOT_CHANNEL,
    channel,
  };
}

export function getJiraIssues(jiraissues) {
  return {
    type: GET_JIRA_ISSUES,
    jiraissues,
  };
}
export function getJsdRequestTypes(jiraissues) {
  return {
    type: 'GET_JSD_REQUEST_TYPES',
    jiraissues,
  };
}

export function getJiraProjects(jiraprojects, second) {
  return {
    type: GET_JIRA_PROJECTS,
    jiraprojects,
  };
}
export function addJiraProjectsFromDropdown(jiraprojects) {
  return {
    type: ADD_JIRA_PROJECTS,
    jiraprojects,
  };
}
export function getJSDProjects(jiraprojects) {
  return {
    type: 'GET_JSD_PROJECTS',
    jiraprojects,
  };
}
export function getJiraStatuses(statuses) {
  return {
    type: GET_JIRA_STATUSES,
    statuses,
  };
}

export function getGitHubProjects(repositories) {
  return {
    type: 'GET_GITHUB_PROJECTS',
    repositories,
  };
}

export function setJiraPersonalChannelDefault(personal_link_info) {
  return {
    type: SET_DEFAULT_JIRA_PERSONAL_CHANNEL,
    personal_link_info,
  };
}

export function deleteJiraPersonalChannelDefaultLinking() {
  return {
    type: 'DELETE_DEFAULT_JIRA_PERSONAL_CHANNEL_LINKING',
  };
}
export function setWorkspaceAdmin(admins) {
  return {
    type: 'SET_WORKSPACE_ADMINS',
    admins,
  };
}

export function setJiraDefaultChannel(link_info) {
  // console.log(link_info)
  return {
    type: SET_DEFAULT_JIRA_CHANNEL,
    link_info,
  };
}

export function deleteJiraDefaultChannelLinking() {
  return {
    type: 'DELETE_DEFAULT_JIRA_CHANNEL_LINKING',
  };
}

export function setSkill(skill) {
  return {
    type: SET_SKILL_DATA,
    skill,
  };
}

export function setCurrentSkillUser(skillUser) {
  return {
    type: SET_CURRENT_SKILL_USER,
    skillUser,
  };
}

export function getnotifConfig(getNotif) {
  return {
    type: GET_JIRA_NOTIFICATION_CONFIGURATION,
    getNotif,
  };
}

export function setnotifConfig(setNotif) {
  return {
    type: SET_JIRA_NOTIFICATION_CONFIGURATION,
    setNotif,
  };
}

export function getUserNotifConfig(getUserNotif) {
  return {
    type: GET_JIRA_USER_NOTIFICATION_CONFIGURATION,
    getUserNotif,
  };
}

export function setUserNotifConfig(setUserNotif) {
  return {
    type: SET_JIRA_USER_NOTIFICATION_CONFIGURATION,
    setUserNotif,
  };
}

export function setSlackLink(linked) {
  return {
    type: SET_SLACK_LINK,
    linked,
  };
}

export function setSlackChannels(channels) {
  return {
    type: SET_SLACK_CHANNELS,
    channels,
  };
}

export function setSlackChannelsData(channelData) {
  return {
    type: GET_CHANNEL_DATA,
    channelData,
  };
}

export function fetchSkillData(skills) {
  return {
    type: GET_SKILL,
    skills,
  };
}

export function emailSubscription(subscription) {
  return {
    type: EMAIL_SUBSCRIPTION,
    subscription,
  };
}

export function getUserTokenData(userData) {
  return {
    type: 'GET_USER_TOKEN',
    userData,
  };
}

export function setAllGitHubChannelConfig(channelConfigs) {
  return {
    type: 'GET_GIT_CHANNEL_CONFIG',
    channelConfigs,
  };
}

export function setAllJiraChannelConfig(jiraChannelConfigs) {
  return {
    type: 'GET_JIRA_CHANNEL_CONFIG',
    jiraChannelConfigs,
  };
}

export function setJiraBoards(boards) {
  return {
    type: GET_JIRA_BOARDS,
    boards,
  };
}
export function setBoardStatuses(statuses) {
  return {
    type: 'SET_BOARD_STATUSES',
    statuses,
  };
}
export function setJiraBoardSprint(sprints) {
  return {
    type: SET_JIRA_BOARD_SPRINTS,
    sprints,
  };
}

export function setCurrentSkill(skill) {
  return {
    type: SET_CURRENT_SKILL,
    skill,
  };
}

export function setCurrentTeamsync(teamSync) {
  // console.log("SETD SKILL SET SKILL SERT SKILL")
  return {
    type: SET_CURRENT_TEAMSYNC,
    teamSync,
  };
}

export function deleteJiraChannelConfig(id) {
  return {
    type: 'DELETE_JIRA_CONFIG',
    id,
  };
}

//standups:my standups

export const setUsersTeamSyncs = (teamSyncs) => {
  return {
    type: SET_USER_TEAMSYNCS,
    teamSyncs,
  };
};

export const setUserTeamSync = (teamsync) => {
  return {
    type: SET_USER_TEAMSYNC,
    teamsync,
  };
};

// getAllUsers
export const AllUsers = (allUsers) => {
  return {
    type: 'GET_ALL_USERS',
    allUsers,
  };
};
export const setBotUsers = (botUsers) => {
  return {
    type: SET_BOT_USERS,
    botUsers,
  };
};
export const deleteUserTeamSync = (id) => {
  return {
    type: DELETE_USER_TEAMSYNC,
    id,
  };
};
//standups: show reports

export function setProjectTeamSyncInstance(instance) {
  return {
    type: SET_TEAM_SYNC_INSTANCE,
    instance,
  };
}

export function setProjectProgressReports(reports) {
  return {
    type: SET_PROJECT_PROGRESS_REPORTS,
    reports,
  };
}
export function setProjectTeamSyncInstanceResponse(response) {
  return {
    type: SET_TEAM_SYNC_INSTANCE_RESPONSE,
    response,
  };
}
// Standup : Resume Now
export const updateUserTeamSyncs = (teamSync) => {
  return {
    type: UPDATE_USER_TEAMSYNCS,
    teamSync,
  };
};

export const updateUserTeamSyncsList = (teamSync) => {
  return {
    type: 'UPDATE_USER_TEAMSYNCS_LIST',
    teamSync,
  };
};

// teamsync analytics
export function setWorkspaceTeamSyncData({
  totalResponses,
  membersResponse,
  totalResponded,
  repliedResponsesCount,
  totalLikes,
  totalComments,
  totalMoodResponses,
  userMoodTotal,
  participation,
  moodChart,
  responsesGroupedByTeamMoodScore,
}) {
  return {
    type: 'SET_WORKSPACE_TEAM_SYNC_DATA',
    totalResponses,
    membersResponse,
    totalResponded,
    repliedResponsesCount,
    totalLikes,
    totalComments,
    totalMoodResponses,
    userMoodTotal,
    participation,
    moodChart,
    responsesGroupedByTeamMoodScore,
  };
}

export function setStandupHistory(data) {
  return {
    type: 'SET_STANDUP_HISTORY',
    data,
  };
}

export function updateStandupHistory(data) {
  return {
    type: 'UPDATE_STANDUP_HISTORY',
    data,
  };
}

export function setUserMappingsAndUsers(payload) {
  return {
    type: GET_USERMAPPING_USERS,
    payload,
  };
}
export function deleteMappedUser(umId) {
  return {
    type: DELETE_USER_MAPPING,
    id: umId,
  };
}

export function editUserMappinginStore(data) {
  return {
    type: EDIT_USER_MAPPING,
    data,
  };
}

export function setJiraUsers(users) {
  return {
    type: SET_JIRA_USERS,
    users,
  };
}
export function setLoading(value) {
  return {
    type: SET_LOADING,
    value,
  };
}
export function addUserMappingToStore(data) {
  return {
    type: ADD_USER_MAPPING,
    data,
  };
}

// TO get all workspace members
export function setWorkspaceMembers(members) {
  return {
    type: SET_WORKSPACE_MEMBERS,
    members,
  };
}

// To update user info
export function setUser(user) {
  return {
    type: SET_USER,
    user,
  };
}

export function setWorkspace(workspace) {
  return {
    type: SET_WORKSPACE,
    workspace,
  };
}

export function setRecentTeamsyncs(teamsyncs) {
  return {
    type: 'set_recent_teamsyncs',
    teamsyncs,
  };
}

export function setConfluenceSpaces(spaces) {
  return {
    type: SET_CONFULENCE_SPACES,
    spaces,
  };
}

export function setConfluenceChannelConfig(config) {
  return {
    type: SET_CONFULENCE_CHANNEL_CONFIG,
    config,
  };
}
export function addConfluenceChannelConfigtoStore(config) {
  return { type: ADD_CONFLUENCE_CHANNEL_CONFIG, config };
}
export function setConfluenceChannelConfigList(configs) {
  return {
    type: SET_CONFULENCE_CHANNEL_CONFIG_LIST,
    configs,
  };
}

// export const changeClassName = (data) => {
//   return {
//     type: "CHANGE_CLASSNAME",
//     data
//   }
// }

/*export function getAssisantSkills(id){
    return dispatch => {    
        // return axios.get("http://app.troopr.io/bot/workspace/"+id+"/assistant_skills",options)
           return axios.get("/bot/workspace/"+id+"/skills")
                    .then(res =>{
                     // console.log("we")
                      if(res.data.success){
                          dispatch(setAssisantSkills(res.data.skills))
                       }
            return res;
          })
       }
    }*/

// export function emailSubscribe(wId, data) {

//   return dispatch => {
//     return axios.post("/bot/api/" + wId + "/setEmailSubscription", data)
//       .then(res => {
//         // console.log("res====>")
//         if (res.data.success) {

//         }
//       })
//   }

// }

// export function getEmailSubscription(wId, data) {
//   return dispatch => {
//     return axios.get("/bot/api/" + wId + "/setEmailSubscription")
//       .then(userData => {
//         // console.log("data for get emaik====>",userData.data.data.email_subscription)
//         // dispatch(emailSubscription(userData.data.data.email_subscription));
//         return userData;
//       })
//   }

// }

// export function setJiraConnectId(wId, data) {

//   return dispatch => {
//     // return axios.post("/bot/api/" + wId + "/setJiraConnectedId", data)
//     return axios.post("/bot/api/w/" + wId + "/skill", data)
//       .then(res => {

//       })
//   }
// }

// export function setGitHubConnectId(wId, data) {

//   return dispatch => {
//     return axios.post("/bot/api/" + wId + "/setGitHubConnectId", data)
//       .then(res => {

//       })
//   }
// }

export async function checkJiraTokenValidity({ userId, skillId, wId }) {
  let url = `/bot/api/w/${wId}/jira/${skillId}/verifytoken`;
  if (userId) url += `?userId=${userId}`;
  const response = await axios.post(url, { skillId: skillId });
  return response;
}

export async function checkConfluenceTokenValidity(userId, skillId, wId) {
  const response = await axios.post(
    `/bot/api/w/${wId}/wiki/${skillId}/verifytoken?userId=${userId}`
  );

  return response;
}

export function getAssisantSkills(wId) {
  return (dispatch) => {
    // return axios.get("/bot/api/" + id + "/skills")
    return axios.get('/bot/api/w/' + wId + '/skills').then((res) => {
      if (res && res.data && res.data.success) {
        dispatch(setAssisantSkills(res.data.skills));
      }
      return res;
    });
  };
}

export function recentCheckins(tId, wId) {
  return (dispatch) => {
    // return axios.post(`/api/${wId}/teamsync/${tId}/updateRecentTeamsync`, {})
    return axios
      .post(`/api/w/${wId}/teamSync/${tId}/recentTeamsync`, {})
      .then((res) => {
        if (res && res.data && res.data.success) {
          dispatch(setRecentTeamsyncs(res.data.teamsyncs));
        }
        return res;
      });
  };
}

export function getRecentTeamsyncs(wId) {
  return (dispatch) => {
    // return axios.get('/api/'+wId+'/teamsyncs_recent')
    return axios
      .get('/api/w/' + wId + '/teamSync/recentTeamsync')
      .then((res) => {
        if (res && res.data && res.data.success) {
          dispatch(setRecentTeamsyncs(res.data.teamsyncs));
        }
        return res;
      });
  };
}

export function deleteRecentTeamsync(wId, tId) {
  return (dispatch) => {
    // return axios.post(`/api/${wId}/teamsync/${tId}/deleteRecentTeamsync`, {})
    return axios
      .delete(`/api/w/${wId}/teamSync/${tId}/recentTeamsync`)
      .then((res) => {
        if (res && res.data && res.data.success) {
          dispatch(setRecentTeamsyncs(res.data.teamsyncs));
        }

        return res;
      });
  };
}
//Get jira channel based Notification.
export function getJiraNotifConfig(
  wId,
  channel_id,
  skillId,
  projId,
  isGridSharedChannel,
  subscription_id
) {
  // let link = "/bot/api/workspace/" + wId + "/get_notification_config/" + channel_id + "/" + skillId + "/" + projId
  if (!projId) {
    projId = 'projId';
  }
  let link =
    '/bot/api/w/' +
    wId +
    '/channelConfig/notifConfig/' +
    channel_id +
    '/' +
    skillId +
    '/' +
    projId;

  if (isGridSharedChannel) {
    link += '?isGridSharedChannel=true';
    if (subscription_id) {
      link += '&subscription_id=' + subscription_id;
    }
  } else if (subscription_id) {
    link += '?subscription_id=' + subscription_id;
  }

  // console.log(link)
  return (dispatch) => {
    return axios.get(link).then((res) => {
      if (res.data && res.data.success) {
        dispatch(getnotifConfig(res.data.data));
      }
      return res;
    });
  };
}

//Set jira channel based Notification.
export function setJiraNotifConfig(wId, skill_id, data, isGridSharedChannel) {
  // let link = "/bot/api/workspace/" + wId + "/set_notification_config/" + skill_id
  let link = '/bot/api/w/' + wId + '/channelConfig/notifConfig/' + skill_id;
  if (isGridSharedChannel) link += '?isGridSharedChannel=true';
  return (dispatch) => {
    return axios.post(link, data).then((res) => {
      if (res.data && res.data.success) {
        // console.log()
        dispatch(getnotifConfig(res.data.data));
      }
      return res;
    });
  };
}

//Get jira user based Notification.
export function getJiraUserNotifConfig(wId, userId, skill_id) {
  //  console.log("skill_id??????????",skill_id)
  return (dispatch) => {
    // return axios.get("/bot/api/" + wId + "/jira_user_notif_config/" + skill_id)
    return axios
      .get(
        '/bot/api/w/' +
          wId +
          '/jira_user_notif_config/' +
          skill_id +
          '?user_id=' +
          userId
      )
      .then((res) => {
        if (res.data && res.data.success) {
          dispatch(getUserNotifConfig(res.data));
        }
        return res;
      });
  };
}

export const setUserJiraNotifConfig = (wId, skill_id, data) => {
  return (dispatch) => {
    // return axios.post("/bot/api/" + wId + "/jira_user_notif_config/" + skill_id, data)
    return axios
      .post('/bot/api/w/' + wId + '/user/notifConfig/' + skill_id, data)
      .then((res) => {
        if (res.data && res.data.success) {
          dispatch(getUserNotifConfig(res.data));
        }
        return res;
      });
  };
};

// export const getGitHubChannelConfig = (wId, skillId, channelId, repoId) => {
//   let id;

//   if (repoId) {
//     id = repoId
//   } else {
//     id = ""
//   }
//   return dispatch => {
//     return axios.get("/bot/api/" + wId + "/gitHubConfig/" + skillId + "/" + channelId, {
//       params: {
//         repoId: id
//       }
//     })
//       .then(res => {

//         return res;

//       })
//   }
// }

// export const getGitHubUserConfig = (wId, skillId, channelId) => {
//   return dispatch => {
//     return axios.get("/bot/api/" + wId + "/gitHubUserConfig/" + skillId + "/" + channelId)
//       .then(res => {

//         return res;

//       })
//   }
// }

// export const getAllGitHubChannelConfig = (wId, skillId, channelId) => {
//   return dispatch => {
//     return axios.get("/bot/api/" + wId + "/allGitHubConfig/" + skillId + "/" + channelId)
//       .then(res => {
//         dispatch(setAllGitHubChannelConfig(res.data.data));
//         return res;

//       })
//   }
// }

export const getAllJiraConfigs = (
  wId,
  skillId,
  channelId,
  isGridSharedChannel
) => {
  // let link = "/bot/api/" + wId + "/allJiraConfig/" + skillId + "/" + channelId
  let link =
    '/bot/api/w/' + wId + '/allJiraConfig/' + skillId + '/' + channelId;
  if (isGridSharedChannel) {
    link += '?isGridSharedChannel=true';
  }
  return (dispatch) => {
    return axios.get(link).then((res) => {
      // console.log("getAllJiraConfigs==>",res)
      dispatch(setAllJiraChannelConfig(res.data.data));
      return res;
    });
  };
};

// export const setGitHubChannelConfig = (wId, skillId, data) => {
//   let userId = data.user_id;
//   //  console.log("data=======>",data)
//   return dispatch => {
//     return axios.post("/bot/api/" + wId + "/gitHubConfig/" + skillId + "/" + userId, data)
//       .then(res => {

//         return res;

//       })
//   }

// }

// export const setGitHubUserChannelConfig = (wId, skillId, data) => {
//   let userId = data.user_id;
//   //  console.log("data=======>",data)
//   return dispatch => {
//     return axios.post("/bot/api/" + wId + "/gitHubUserConfig/" + skillId + "/" + userId, data)
//       .then(res => {

//         return res;

//       })
//   }

// }

// export const getMappedUser = (wId,skillId, userId) => {
//   return dispatch => {
//     // return axios.get("/bot/api/" + skillId + "/user/" + userId)
//     return axios.get(`/bot/api/w/${wId}/jira/mappedUser/${skillId}/user/${userId}`)
//       .then(res => {

//         return res;

//       })
//   }
// }

export const deleteUserConfig = (wId, skillId, channelId) => {
  return (dispatch) => {
    // return axios.get("/bot/api/deleteUserConfig/" + wId + "/" + skillId + "/channelId/" + channelId)
    return axios
      .delete(
        `/bot/api/w/${wId}/user/notifConfig/${skillId}/channelId/${channelId}`
      )
      .then((res) => {
        return res;
      });
  };
};

export function getBotChannel(wId, user_id) {
  return (dispatch) => {
    // return axios.get('/bot/slack/channels/' + id + '/botchannel/' + user_id)
    return (
      axios
        .get(
          `/bot/api/w/${wId}/user/notifConfig/channels/botchannel/${user_id}`
        )
        //
        .then((res) => {
          if (res.data && res.data.success) {
            dispatch(setBotChannel(res.data.channel));
          }
          return res;
        })
    );
  };
}

//Get projects based on skill Id
export function getProject(wId, isFromJiraConnectionOnboarding, user_id) {
  return (dispatch) => {
    dispatch(getJiraProjects([]));
    // let link = '/bot/jira/' + id + '/project'
    let link = '/bot/api/w/' + wId + '/jira/project';
    if (isFromJiraConnectionOnboarding)
      link += '?isFromJiraConnectionOnboarding=true';

    if (user_id) {
      link += '?user_id=' + user_id;
    }
    return axios.get(link).then((res) => {
      if (res.data && res.data.success) {
        dispatch(getJiraProjects(res.data.projects));
      } else {
        dispatch(getJiraProjects([]));
      }
      return res;
    });
  };
}

export function emptyProjectValues() {
  return (dispatch) => {
    dispatch(getJiraProjects([]));
    dispatch(getJSDProjects([]));
  };
}

export function searchJiraProjects(wId, query, isFromJiraConnectionOnboarding) {
  return (dispatch) => {
    dispatch(getJiraProjects([]));
    // return axios.get(`/bot/jira/${id}/searchJiraProject${query || ''}`)
    let link = `/bot/api/w/${wId}/jira/searchJiraProject${query || ''}`;
    if (isFromJiraConnectionOnboarding)
      link += query
        ? '&isFromJiraConnectionOnboarding=true'
        : '?isFromJiraConnectionOnboarding=true';
    return (
      axios
        // .get(`/bot/api/w/${wId}/jira/searchJiraProject${query || ''}`)
        .get(link)
        .then((res) => {
          if (
            res.data &&
            res.data.success &&
            res.data.projectsData &&
            res.data.projectsData.values
          ) {
            dispatch(getJiraProjects(res.data.projectsData.values));
          } else {
            dispatch(getJiraProjects([]));
          }

          return res;
        })
    );
  };
}

export const getServiceDeskProject =
  (wId, skill_id, additionalData) => (dispatch) => {
    if (additionalData && additionalData.saveInJSDProjects)
      dispatch(getJSDProjects([]));
    else if (additionalData && additionalData.saveInBoth) {
      dispatch(getJSDProjects([]));
      dispatch(getJiraProjects([]));
    } else dispatch(getJiraProjects([]));
    // let link = `/bot/jira/workspace/${wId}/skill/${skill_id}/ServiceDeskProject`
    let link = `/bot/api/w/${wId}/jira/skill/${skill_id}/ServiceDeskProject`;
    if (additionalData && additionalData.isFromJiraConnectionOnboarding)
      link += '?isFromJiraConnectionOnboarding=true';
    if (additionalData && additionalData.user_id)
      link += '?user_id=' + additionalData.user_id;

    return axios.get(link).then((res) => {
      if (res.data.success) {
        if (additionalData && additionalData.saveInJSDProjects)
          dispatch(getJSDProjects(res.data.serviceDeskProjects));
        else if (additionalData && additionalData.saveInBoth) {
          dispatch(getJSDProjects(res.data.serviceDeskProjects));
          dispatch(getJiraProjects(res.data.serviceDeskProjects));
        } else dispatch(getJiraProjects(res.data.serviceDeskProjects));
      } else {
        if (additionalData && additionalData.saveInJSDProjects)
          dispatch(getJSDProjects([]));
        else if (additionalData && additionalData.saveInBoth) {
          dispatch(getJSDProjects([]));
          dispatch(getJiraProjects([]));
        } else dispatch(getJiraProjects([]));
      }
      return res.data;
    });
  };

//Get projects based on skill Id
export function getJiraBoards(wId, query) {
  return (dispatch) => {
    // return axios.get("/bot/api/workspace/" + wId + "/getAllBoardsApi?" + query)
    return axios
      .get('/bot/api/w/' + wId + '/jira/getAllBoardsApi?' + query)
      .then((res) => {
        if (res.data && res.data.success) {
          dispatch(setJiraBoards(res.data.boards));
        }
        return res;
      });
  };
}

export function getBoardStatuses(wId, boardId) {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/getBoardStatuses/${boardId}`)
    return axios
      .get(`/bot/api/w/${wId}/jira/getBoardStatuses/${boardId}`)
      .then((res) => {
        if (res.data && res.data.success) {
          // dispatch(setJiraBoards(res.data.boards));
          dispatch(setBoardStatuses(res.data.statuses));
        }
        return res;
      });
  };
}

export function getJiraBoardSprint(wId, id) {
  return (dispatch) => {
    // return axios.get("/bot/api/workspace/" + wId + "/getBoardsSprints/" + id)
    return axios
      .get('/bot/api/w/' + wId + '/jira/getBoardsSprints/' + id)
      .then((res) => {
        if (res.data && res.data.success) {
          dispatch(setJiraBoardSprint(res.data.sprints));
        }
        return res;
      });
  };
}

// export function getGitHubRepository(wId) {
//   return dispatch => {
//     return axios.get('/bot/api/github/' + wId + '/getRepos')
//       .then(res => {
//         //  console.log("=======>",res)
//         if (res.data.success) {
//           dispatch(getGitHubProjects(res.data.repositories));

//         }
//         return res;

//       })
//   }

// }

//get issue based on project Id
export function getIssues(
  wId,
  pId,
  isSupportChannel,
  saveInJSDProjects,
  isFromJiraOnboarding,
  user_id
) {
  return (dispatch) => {
    // let link = '/bot/jira/' + wId + '/project/' + pId
    let link = '/bot/api/w/' + wId + '/jira/project/' + pId;
    if (isSupportChannel) {
      link += '?isSupportChannel=true'; /*  to get request type */

      if (user_id) {
        link += '&user_id=' + user_id;
      }
    } else if (user_id) {
      if (user_id) {
        link += '?user_id=' + user_id;
      }
    }

    return axios.get(link).then((res) => {
      if (res.data && res.data.success) {
        if (saveInJSDProjects || isFromJiraOnboarding)
          dispatch(getJsdRequestTypes(res.data.issueTypes));
        else dispatch(getJiraIssues(res.data.issueTypes));
      } else {
        if (saveInJSDProjects) dispatch(getJsdRequestTypes([]));
        else dispatch(getJiraIssues([]));
      }
      return res;
    });
  };
}

export function getDefaultChannel(
  wId,
  skill_id,
  channel_id,
  type,
  isGridSharedChannel
) {
  return (dispatch) => {
    // let link = '/bot/skill/' + id + '/channel_link/' + channel_id
    let link = `/bot/api/w/${wId}/channelConfig/skill/${skill_id}/channel_link/${channel_id}`;
    if (isGridSharedChannel) link += `?isGridSharedChannel=true`;
    return axios.get(link).then((res) => {
      if (res.data && res.data.success) {
        if (type) {
          dispatch(setJiraPersonalChannelDefault(res.data.link_info));
        } else {
          dispatch(setJiraDefaultChannel(res.data.link_info));
        }
      }
      return res;
    });
  };
}

//delete channel_link
export function deleteDefaultChannel(
  wId,
  skill_id,
  channel_id,
  isPersonal,
  isGridSharedChannel
) {
  // let link = `/bot/skill/${id}/channel_link/${channel_id}`
  let link = `/bot/api/w/${wId}/channelConfig/skill/${skill_id}/channel_link/${channel_id}`;
  if (isGridSharedChannel) {
    link += '?isGridSharedChannel=true';
  }
  return (dispatch) => {
    return axios.delete(link).then((res) => {
      if (res.data.success) {
        if (isPersonal) {
          dispatch(deleteJiraPersonalChannelDefaultLinking());
        } else {
          dispatch(deleteJiraDefaultChannelLinking());
        }
      }
      return res.data;
    });
  };
}

export function setDefaultChannel(
  wId,
  skill_id,
  data,
  type,
  isGridSharedChannel
) {
  return (dispatch) => {
    // let link = '/bot/skill/' + id + '/channel_link'
    let link = `/bot/api/w/${wId}/channelConfig/defaults/skill/${skill_id}/channel_link`;
    if (isGridSharedChannel) {
      link += '?isGridSharedChannel=true';
    }
    return axios.post(link, data).then((res) => {
      if (res.data.success) {
        if (type) {
          dispatch(setJiraPersonalChannelDefault(res.data.link_info));
        } else {
          dispatch(setJiraDefaultChannel(res.data.link_info));
        }

        if (res.data.commonConfig)
          dispatch(updateCommonChannelData(res.data.commonConfig));
      }
      return res;
    });
  };
}

export function creatorAsAssignee({
  wId,
  skill_id,
  channel_id,
  channel,
  isGridSharedChannel,
}) {
  return (dispatch) => {
    let link = `/bot/api/w/${wId}/channelConfig/defaults/skill/${skill_id}/channel_link/creatorAsAssignee/${channel_id}`;
    // /bot/api/w/:wId/channelConfig/defaults/skill/${skill_id}/channel_link/creatorAsAssignee/${channel_id}`

    if (isGridSharedChannel) link += `?isGridSharedChannel=true`;
    return axios
      .post(link, { channel })
      .then((res) => {
        if (res && res.data && res.data.success) {
          dispatch(setJiraDefaultChannel(res.data.link_info));
        }
        return res;
      })
      .catch((error) => {});
  };
}

//Get all the channel list based on workspace ID both private and public
export function getChannelList(wId, query) {
  let q = '';
  if (query) {
    q = '?' + query;
  }
  return (dispatch) => {
    // return axios.get('/bot/api/' + id + '/slack/getChannels' + q).then(res => {
    return axios
      .get('/bot/api/w/' + wId + '/team/slack/getChannels' + q)
      .then((res) => {
        if (res && res.data && res.data.success) {
          dispatch(getChannel(res.data.channels));
        }
        return res;
      });
  };
}

//Get all the channel list based on workspace ID both private and public
export function getBotInvitedChannelList(wId) {
  return (dispatch) => {
    // return axios.get('/bot/api/' + id + '/slack/getChannels' + q).then(res => {
    return axios
      .get('/bot/api/w/' + wId + '/team/slack/getInvitedChannels')
      .then((res) => {
        if (res && res.data && res.data.success) {
          dispatch(getInvitedChannel(res.data.channels));
        }
        return res;
      });
  };
}

export const createDefaultChannels = (wId, data) => {
  return (dispatch) => {
    return axios
      .post('/bot/api/w/' + wId + '/channelConfig/channelDefault', data)
      .then((res) => {
        if (res.data.newChannelData)
          dispatch(updateChannel(res.data.newChannelData));
        return res;
      });
  };
};

export const resetChannelsList = () => (dispatch) => {
  return dispatch(getChannel([]));
};

//get a channel info
export function getChannelInfo(wId, channelId) {
  return (dispatch) => {
    // return axios.get('/bot/api/' + wid + '/slack/conversation/' + channelId).then(res => {
    return axios
      .get('/bot/api/w/' + wId + '/team/slack/conversation/' + channelId)
      .then((res) => {
        if (res.data.success) {
        }
        return res;
      });
  };
}

//get current skill

export function getCurrentSkill(wId, query) {
  return (dispatch) => {
    // return axios.get("/bot/api/" + wId + "/getSkill?" + query)
    return axios.get('/bot/api/w/' + wId + '/skill?' + query).then((res) => {
      // console.log(res.data)
      if (res.data.success) {
        dispatch(setCurrentSkill(res.data.skill));
      }
      return res;
    });
  };
}

//Get skill data based on skillID
export function getSkillData(wId, id) {
  return (dispatch) => {
    // return axios.get('/bot/getSkill/' + id)
    return axios.get(`/bot/api/w/${wId}/skill/${id}`).then((res) => {
      if (res.data.success) {
        dispatch(setSkill(res.data.skill));
      }
      return res;
    });
  };
}

// getSkillId
export function getSkillId(wId, type) {
  return (dispatch) => {
    // return axios.get('/bot/getSkillId/workspace/' + wId + "/type/" + type)
    return axios
      .get(`/bot/api/w/${wId}/skill/workspace/type/${type}`)
      .then((res) => {
        if (res.data.success) {
          return res.data.data;
        }
      });
  };
}

// export function saveDataTrooprConfigs(wId, data) {
//   return dispatch => {
//     return axios.post('/bot/workspace/' + wId + "/saveDataTrooprConfigs", data)
//       .then(res => {
//         // console.log("res=========>", res);
//         if (res.data.success) {
//           return res.data.data

//         }

//       })
//   }
// }

// export function getTrooprChannelConfig(skillId, wId, pId) {
//   return dispatch => {
//     return axios.get('/bot/workspace/' + wId + "/skill/" + skillId + "/getDataTrooprConfigs/" + pId)
//       .then(res => {
//         // console.log("res=========>getChannelConfig", res);

//         return res

//       })
//   }
// }

// export function getTrooprUserChannelConfig(skillId, wId, uId) {
//   return dispatch => {
//     return axios.get('/bot/workspace/' + wId + "/skill/" + skillId + "/getDataTrooprUserConfigs/" + uId)
//       .then(res => {
//         // console.log("res=========>getChannelConfig", res);

//         return res

//       })
//   }
// }

export function getSkillUser(wId, skill_id) {
  return (dispatch) => {
    // return axios.get("/api/workspace/" + id + "/getSkill/" + skill_id + "/user")
    return axios.get(`/api/w/${wId}/skill/${skill_id}/user`).then((res) => {
      if (res && res.data && res.data.success) {
        dispatch(setCurrentSkillUser(res.data.skillUser));
      } else if (
        !(res && res.data && res.data.success) &&
        res &&
        res.data &&
        res.data.message == 'No User Found'
      ) {
        dispatch(setCurrentSkillUser({}));
      }
      return res;
    });
  };
}

//Logout/Unlink Jira user
export function logOutSkillUser(wId, skill_id, user_id) {
  return (dispatch) => {
    // return axios.post("/api/workspace/" + id + "/getSkill/" + skill_id + "/user_logout")
    return axios
      .post(`/bot/api/w/${wId}/skill/${skill_id}/user_logout/${user_id}`)
      .then((res) => {
        if (res.data.success) {
          dispatch(setCurrentSkillUser({}));
        }
        return res;
      });
  };
}

// export function unlinkGitUser(wId, skill_id, user_id) {
//   return dispatch => {
//     // return axios.post("/bot/api/workspace/" + wId + "/skill/" + skill_id + "/user_logout/" + user_id)
//     return axios.post(`/bot/api/w/${wId}/skill/${skill_id}/user_logout/${user_id}`)
//       .then(res => {
//         if (res.data.success) {
//           dispatch(setCurrentSkillUser({}));
//         }
//         return res;
//       })
//   }
// }

export function updateSkill(
  skill_id,
  wId,
  data,
  currentSkill,
  dontUpdateCurrentSkill
) {
  return (dispatch) => {
    // return axios.put("/bot/api/workspace/" + workspace_id + "/assistant_skills_update/" + id, data)
    return axios
      .put(`/bot/api/w/${wId}/skill/assistant_skills_update/${skill_id}`, data)
      .then((res) => {
        if (res.data.success) {
          dispatch(setSkill(res.data.skill));

          dispatch(updateAssisantSkills(res.data.skill));
          if (res.data.skill.userToken == null) {
            dispatch(getUserTokenData({ userName: null, userToken: null }));
            if (!dontUpdateCurrentSkill)
              dispatch(setCurrentSkill(res.data.skill));
          }
        }
        return res;
      });
  };
}
export function updateGlobalJiraNotif(wId, sId, data) {
  return (dispatch) => {
    // return axios.put("/bot/"+wId+"/skill/"+sId+"/updateJiraGlobalNotif", data)
    return axios
      .put(`/bot/api/w/${wId}/skill/${sId}/updateJiraGlobalNotif`, data)
      .then((res) => {
        if (res.data.success) {
          dispatch(setSkill(res.data.skill));
          dispatch(setCurrentSkill(res.data.skill));
        }
        return res;
      });
  };
}
//Redirects to jira connection page
export function getSkillConnectUrl(type, wId, location) {
  return (dispatch) => {
    let query = 'type=' + type + '&workspace_id=' + wId;
    if (location) {
      query = query + '&location=' + location;
    }
    // return axios.get("/api/skillConnectUrl?" + query)
    return axios.get(`/api/w/${wId}/skill/connectUrl?` + query).then((res) => {
      if (res.data.success) {
      }
      return res;
    });
  };
}

//Check weather workspace is connected to slack or not.
export function checkSlackLink(wId) {
  return (dispatch) => {
    // return axios.get('/api/slack/checkSlackLink/' + id)
    return axios.get(`/bot/api/w/${wId}/team`).then((res) => {
      // dispatch(setSlackLink(res.data.linked));
      if (res.data.success) {
        // dispatch(setSlackChannels(res.data.channels));
        dispatch(setSlackChannelsData(res.data.team));
      }
      return res;
    });
  };
}

export function getuserMapping(sId, uId, wId) {
  return (dispatch) => {
    // return axios.get('/bot/api/workspace/' + wId + '/skill/' + sId + '/usermapping/' + uId)
    return axios
      .get(`/bot/api/w/${wId}/skill/${sId}/usermapping/${uId}`)
      .then((res) => {
        if (res.data.success) {
          return res;
        }
      });
  };
}

//Fetch skills both system and custom
// export function fetchSkills(id) {
//   return dispatch => {
//     return axios.get('/bot/api/' + id + '/skills')
//       .then(res => {
//         if (res.data.success) {
//           dispatch(fetchSkillData(res.data.skills));
//         }
//         return res;
//       })
//   }
// }

export function submitTokenData(wId, data, currentskill) {
  return (dispatch) => {
    // return axios.post('/bot/api/' + wId + '/submitTokenData', data)
    return axios
      .post(`/bot/api/w/${wId}/skill/submitTokenData`, data)
      .then((res) => {
        if (res.data.success) {
          let userData = {
            userName: data.userName,
            userToken: data.userToken,
          };
          dispatch(getUserTokenData(userData));
          dispatch(setCurrentSkill(res.data.skill));
          res.data.skill.name === 'Jira' &&
            dispatch(updateAssisantSkills(res.data.skill));
        }
        return res;
      });
  };
}

export function getUserToken(wId, name) {
  return (dispatch) => {
    // return axios.get("/bot/api/" + wId + "/getTokenData/" + name)
    return axios
      .get(`/bot/api/w/${wId}/skill/getTokenData/${name}`)
      .then((res) => {
        if (res.data.data) {
          let userData = {
            userName: res.data.data.userName,
            userToken: res.data.data.userToken,
          };
          dispatch(getUserTokenData(userData));
        }

        return res.data;
      });
  };
}

export function getTeamData(wId) {
  return (dispatch) => {
    // return axios.get("/bot/api/" + wId + "/getTeamData")
    return axios.get('/bot/api/w/' + wId + '/team').then((res) => {
      dispatch(setTeamDetails(res.data.team));
      return res;
    });
  };
}

export function updateTeam(wId, data) {
  return (dispatch) => {
    // return axios.put("/bot/api/workspace/" + wId + "/team",data)
    return axios.put('/bot/api/w/' + wId + '/team', data).then((res) => {
      dispatch(setTeamDetails(res.data.team));
      return res;
    });
  };
}

export function getUser(wId, data) {
  return (dispatch) => {
    // return axios.get("/bot/api/getUserInfo/" + data)
    return axios.get(`/bot/api/w/${wId}/user/info/${data}`).then((res) => {
      return res;
    });
  };
}

export const deleteJiraConfig = (
  wId,
  skillId,
  channelId,
  data,
  isGridSharedChannel
) => {
  // let link = "/bot/api/" + wId + "/deleteJiraConfig/" + skillId + "/" + channelId
  let link = `/bot/api/w/${wId}/channelConfig/${skillId}/${channelId}/delete`;
  if (isGridSharedChannel) link += '?isGridSharedChannel=true';

  return (dispatch) => {
    return axios.post(link, data).then((res) => {
      dispatch(deleteJiraChannelConfig(data.id));
    });
  };
};

export const addTeamSyncAdmin = (wId, teamSyncId, userId) => {
  return (dispatch) => {
    return (
      axios
        // .post(`/api/teamSync/${teamSyncId}/addTeamSyncAdmin/${userId}`)
        .post(`/api/w/${wId}/teamSync/${teamSyncId}/addTeamSyncAdmin/${userId}`)
        .then((res) => {
          if (res.data.success) {
            dispatch(setUserTeamSync(res.data.updated_teamSync));
            return res;
          } else {
            return res;
          }
        })
        .catch((err) => {
          // //console.error(
          //   'some error occurred while adding team sync admin: ',
          //   err
          // );
        })
    );
  };
};

export const deleteTeamSyncAdmin = (wId, teamSyncId, userId) => {
  return (dispatch) => {
    return (
      axios
        // .post(`/api/teamSync/${teamSyncId}/removeTeamSyncAdmin/${userId}`)
        .post(
          `/api/w/${wId}/teamSync/${teamSyncId}/removeTeamSyncAdmin/${userId}`
        )
        .then((res) => {
          if (res.data.success) {
            dispatch(setUserTeamSync(res.data.updated_teamSync));
            return res;
          } else {
            // //console.error('some error occurred while removing team sync admin');
            return res;
          }
        })
        .catch((err) => {
          //console.error('some error occurred while removing team sync admin');
        })
    );
  };
};

//standups:my standup
export const getUserTeamSync = (wId, id) => {
  return (dispatch) => {
    return (
      axios
        // .get(`/api/getUserTeamSync/${id}`)
        .get(`/api/w/${wId}/teamSync/${id}`)
        .then((res) => {
          if (res && res.data && res.data.success) {
            dispatch(setUserTeamSync(res.data.teamSync));
          } else {
            dispatch({
              type: 'ERROR',
              payload: {
                message: 'not member of this teamsync',
                type: 'TEAMSYNC_MEMBERSHIP',
              },
            });
          }
          return res;
        })
        .catch((e) => {
          dispatch({
            type: 'ERROR',
            payload: {
              message: 'not member of this teamsync',
              type: 'TEAMSYNC_MEMBERSHIP',
            },
          });
          //console.error(e);
        })
    );
  };
};

export const getUsersSelectedTeamSync = (wId, showAll) => {
  return (dispatch) => {
    return (
      axios
        // .get('/api/getUsersSelectedTeamSync/' + id +"?showAll="+showAll)
        .get(`/api/w/${wId}/teamSync/userSelected?showAll=${showAll}`)
        .then((res) => {
          if (res.data.success) {
            dispatch(setUsersTeamSyncs(res.data.teamSyncs));
          } else {
            dispatch({ type: 'ERROR', payload: res.data });
          }
          return res;
        })
        .catch((err) => {
          dispatch({
            type: 'ERROR',
            payload: {
              message: 'not member of this teamsync',
              type: 'TEAMSYNC_MEMBERSHIP',
            },
          });
          // ////console.error(err);
          return err;
        })
    );
  };
};

export const getTeamsyncsCount = (wId, isfromGettingStartedPage) => {
  // let link = `/api/${wId}/getTeamsyncsCount`
  let link = `/api/w/${wId}/teamSync/count`;
  if (isfromGettingStartedPage) link += '?isGettingStarted=true';
  return axios.get(link).then((res) => res.data);
};

export const getJiraConfigurationsCount = (
  wId,
  skill_id,
  isGridWorkspace,
  isJiraAdmin
) => {
  // return axios.get(`/bot/api/${wId}/skill/${skill_id}/getJiraConfigurationsCount?isGridWorkspace=${isGridWorkspace || false}&isJiraAdmin=${isJiraAdmin || false}`).then(res => res.data)
  return axios
    .get(
      `/bot/api/w/${wId}/skill/${skill_id}/getJiraConfigurationsCount?isGridWorkspace=${
        isGridWorkspace || false
      }&isJiraAdmin=${isJiraAdmin || false}`
    )
    .then((res) => res.data);
};

export const getProjectfirstDetails = (wId, user_id, skill_id, data) => {
  // return axios.post(`/bot/api/${wId}/skill/${skill_id}/user/${user_id}/gettingStartedfirst`,data).then((res) => res.data);
  return axios
    .post(
      `/bot/api/w/${wId}/skill/${skill_id}/user/${user_id}/gettingStartedfirst`,
      data
    )
    .then((res) => res.data);
};

// export const getWikiConfigurationCount = (wId,skill_id,isGridWorkspace,isWikiAdmin) => {
//   // return axios.get(`/bot/api/${wId}/skill/${skill_id}/getWikiConfigurationCount?isGridWorkspace=${isGridWorkspace || false}&isWikiAdmin=${isWikiAdmin || false}`).then(res => res.data)
//   return axios.get(`/bot/api/w/${wId}/skill/${skill_id}/getWikiConfigurationCount?isGridWorkspace=${isGridWorkspace || false}&isWikiAdmin=${isWikiAdmin || false}`).then(res => res.data)
// }
export const getJiraChannelPreferencePageData =
  (wId, skill_id, isGridWorkspace, isJiraAdmin) => (dispatch) => {
    // return axios.get(`/bot/api/${wId}/skill/${skill_id}/getJiraChannelPreferencePageData?isGridWorkspace=${isGridWorkspace || false}&isJiraAdmin=${isJiraAdmin || false}`).then(res => {
    return axios
      .get(
        `/bot/api/w/${wId}/skill/${skill_id}/getJiraChannelPreferencePageData?isGridWorkspace=${
          isGridWorkspace || false
        }&isJiraAdmin=${isJiraAdmin || false}`
      )
      .then((res) => {
        if (res.data.success)
          dispatch(setCommonChannelData(res.data.commonData));
        return res.data;
      });
  };

export const getCommonData =
  (
    wId,
    skill_id,
    isWorkspaceAdmin,
    isGridWorkspace,
    channel_ids,
    sharedChannel_ids,
    isPersonalPref
  ) =>
  (dispatch) => {
    // let link = `/bot/api/${wId}/skill/${skill_id}/getCommonData`
    let link = `/bot/api/w/${wId}/skill/${skill_id}/getCommonData`;
    return axios
      .post(link, {
        isWorkspaceAdmin,
        channel_ids,
        sharedChannel_ids,
        isGridWorkspace,
        isPersonalPref,
      })
      .then((res) => {
        if (res.data.success)
          dispatch(setCommonChannelData(res.data.commonData));
        return res.data;
      });
  };

export const deleteChannelConfigurations =
  (wId, data, type) => (dispatch, getStore) => {
    // return axios.post(`/bot/api/workspace/${wId}/deleteChannelConfigurations`,data).then(res => {
    return axios
      .post(`/bot/api/w/${wId}/channelConfig/delete`, data)
      .then((res) => {
        if (res.data.success) {
          if (type === 'personal') {
            dispatch(getUserNotifConfig({}));
            dispatch(deleteJiraPersonalChannelDefaultLinking());
          }
          let commonData = getStore().skills.commonChanneldata;
          dispatch(
            setCommonChannelData(
              commonData.filter((d) => d.channel_id !== data.channel_id)
            )
          );
        }
        return res.data;
      });
  };

export const getJiraReportsCount = (wId) => {
  // return axios.get(`/bot/api/workspace/${wId}/jiraReportsCount`).then(res => res.data)
  return axios
    .get(`/bot/api/w/${wId}/jira/reportsCount`)
    .then((res) => res.data);
};

//standupds:show report

export function getAnotherInstancePage(wId, tId, data) {
  return (dispatch) => {
    // return axios.post(`/api/teamSync/${id}/get_other_instances`, data).then(res => {
    return axios
      .post(`/api/w/${wId}/teamSync/${tId}/get_other_instances`, data)
      .then((res) => {
        if (res.data.success) {
          const { previousInstanceNotAvailable, nextInstanceNotAvailable } =
            res.data.instancePresent;
          dispatch(
            setProjectTeamSyncInstance(res.data.projectTeamSyncInstance)
          );
          dispatch(setProjectProgressReports(res.data.instanceResponses));
          if (previousInstanceNotAvailable && nextInstanceNotAvailable) {
            dispatch({ type: PREV_NXT_INSTANCE_NOT_AVAILABLE });
          } else if (previousInstanceNotAvailable) {
            dispatch({ type: PREV_INSTANCE_NOT_AVAILABLE });
          } else if (nextInstanceNotAvailable) {
            dispatch({ type: NXT_INSTANCE_NOT_AVAILABLE });
          } else {
            dispatch({ type: PREV_NXT_INSTANCE_AVAILABLE });
          }
        } else {
          if (res.data.message) {
            dispatch({ type: GET_INSTANCE_EMPTY, message: res.data.message });
          }
        }
        return res;
      });
  };
}

export function getProjectTeamSyncInstance(
  wId,
  tid,
  instanceID,
  checkIndelete = false
) {
  if (instanceID) {
  } else {
    instanceID = '';
  }
  return (dispatch) => {
    // return axios.get("/api/teamSync/" + id + "/teamSyncInstance/?instanceID=" + instanceID + '&teamSyncId=' + id)
    return axios
      .get(
        `/api/w/${wId}/teamSync/${tid}/teamSyncInstance?instanceID=${instanceID}&teamSyncId=${tid}`
      )
      .then((res) => {
        if (res && res.data && res.data.success) {
          const { previousInstanceNotAvailable, nextInstanceNotAvailable } =
            res.data.instancePresent;
          if (!checkIndelete) {
            dispatch(
              setProjectTeamSyncInstance(res.data.projectTeamSyncInstance)
            );
            dispatch(setProjectProgressReports(res.data.instanceResponses));

            if (previousInstanceNotAvailable && nextInstanceNotAvailable) {
              dispatch({ type: PREV_NXT_INSTANCE_NOT_AVAILABLE });
            } else if (previousInstanceNotAvailable) {
              dispatch({ type: PREV_INSTANCE_NOT_AVAILABLE });
            } else if (nextInstanceNotAvailable) {
              dispatch({ type: NXT_INSTANCE_NOT_AVAILABLE });
            }
          }
        }
        return res;
      });
  };
}

export const deleteTeamInstance = (instanceId, wId, teamSyncId) => {
  return (dispatch) => {
    // return axios.delete(`/api/workspace/${wId}/teamsync/${teamSyncId}/teamSyncInstance/${instanceId}`).then(data => {
    return axios
      .delete(
        `/api/w/${wId}/teamSync/${teamSyncId}/teamSyncInstance/${instanceId}`
      )
      .then((data) => {
        return data;
      });
  };
};

export const getUserMappingAndUsers = (
  wId,
  skillId,
  getCount,
  searchTerm,
  page,
  pageSize,
  filterOption,
  forCheckins
) => {
  return (dispatch) => {
    // let link  = `/bot/workspace/${wId}/getUserMappingsAndUsers/${skillId}`
    let link = `/bot/api/w/${wId}/jira/userMappingsAndUsers/${skillId}`;
    let queryString = '';
    if (getCount) queryString += 'getCount=true';
    if (filterOption) queryString += `&filterOption=${filterOption}`;
    if (searchTerm) queryString += `&searchTerm=${searchTerm}`;
    if (page) queryString += `&page=${page}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;
    if (forCheckins) queryString += `&forCheckins=true`;
    if (queryString) {
      link += `?${queryString}`;
    }
    return axios.get(link).then((res) => {
      if (!getCount) dispatch(setUserMappingsAndUsers(res.data));
      return res;
    });
  };
};

export const deleteUserMapping = (wId, umid) => {
  return (dispatch) => {
    // return axios.delete(`/bot/workspace/${wId}/deleteusermapping/${umid}`).then(res => {
    return axios
      .delete(`/bot/api/w/${wId}/jira/usermapping/${umid}`)
      .then((res) => {
        if (res && res.data && res.data.success)
          dispatch(deleteMappedUser(umid));
      });
  };
};

export const deleteUserMappingsInGridWorkspaces = (wId, user_id, data) => {
  return (dispatch) => {
    return axios
      .put(
        `/bot/api/w/${wId}/jira/deleteUserMappingsInGridWorkspaces/${user_id}`,
        data
      )
      .then((res) => {
        if (res && res.data && res.data.success) {
          const currentWorkspaceUser =
            res.data.deleteResults &&
            res.data.deleteResults.find((item) => item.workspace_id === wId);
          dispatch(deleteMappedUser(currentWorkspaceUser._id));
        }
      });
  };
};

export const getJiraUsers = (wId, skillId, query) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    // return axios.get(`/bot/workspace/skill/${skillId}/jiraUsers?search=${query}`).then(res => {
    return axios
      .get(`/bot/api/w/${wId}/skill/${skillId}/jiraUsers?search=${query}`)
      .then((res) => {
        dispatch(setJiraUsers((res && res.data && res.data.users) || []));
        dispatch(setLoading(false));

        return (res && res.data) || [];
      });
  };
};

export const addUserMapping = (data, workspace_id, skill_id, type) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    // return axios.post(`/bot/workspace/${workspace_id}/addUserMapping/${skill_id}/${type}`, data).then(res => {
    return axios
      .post(
        `/bot/api/w/${workspace_id}/jira/addUserMapping/${skill_id}/${type}`,
        data
      )
      .then((res) => {
        if (res.data.success && !res.data.userexists) {
          dispatch(addUserMappingToStore(res.data.info));
          dispatch(setLoading(false));
          return res;
        } else if (res.data.success && res.data.userexists) {
          dispatch(setLoading(false));
          return res;
        } else {
          dispatch(setLoading(false));
          return res;
        }
      });
  };
};

export const mapUserToGridWorkspaces = (data, workspace_id, skill_id, type) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return axios
      .post(
        `/bot/api/w/${workspace_id}/jira/mapUserToGridWorkspaces/${skill_id}/${type}`,
        data
      )
      .then((res) => {
        if (res.status === 200) {
          const userInfo = res.data.find((item) => item.wId === workspace_id);
          if (userInfo && userInfo.info) {
            dispatch(addUserMappingToStore(userInfo.info));
          }
          dispatch(setLoading(false));
          return res;
        } else if (res.data.success && res.data.userexists) {
          dispatch(setLoading(false));
          return res;
        } else {
          dispatch(setLoading(false));
          return res;
        }
      });
  };
};

export const editUserMapping = (data, workspace_id, umid) => {
  return (dispatch) => {
    dispatch(setLoading(true));

    // return axios.put(`/bot/workspace/${workspace_id}/updateUserMapping/${umid}`,data).then(res => {
    return axios
      .put(`/bot/api/w/${workspace_id}/jira/updateUserMapping/${umid}`, data)
      .then((res) => {
        if (res.data.success && !res.data.userexists) {
          dispatch(setLoading(false));
          dispatch(editUserMappinginStore(res.data.data));
          return res;
        } else if (res.data.success && res.data.userexists) {
          dispatch(setLoading(false));
          return res;
        } else {
          dispatch(setLoading(false));
          return res;
        }
      });
  };
};

export const updateUserMappingInGridWorkspaces = (data, workspace_id) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return axios
      .put(
        `/bot/api/w/${workspace_id}/jira/updateUserMappingInGridWorkspaces`,
        data
      )
      .then((res) => {
        if (res.data.success) {
          const updatedData =
            res.data.data &&
            res.data.data.find((item) => item.workspace_id === workspace_id);
          dispatch(setLoading(false));
          dispatch(editUserMappinginStore(updatedData));
          return res;
        } else if (res.data.success && res.data.userexists) {
          dispatch(setLoading(false));
          return res;
        } else {
          dispatch(setLoading(false));
          return res;
        }
      });
  };
};

// Standup : Resume Now

export function editTeamSync(wId, tId, data) {
  return (dispatch) => {
    // return axios.post('/api/teamSync/' + id + '/teamsyncupdates', data).then(res => {
    return axios
      .post(`/api/w/${wId}/teamSync/` + tId + '/teamsyncupdates', data)
      .then((res) => {
        if (res.data.success) {
          if (
            res.data.teamSync.selectedMembers.length > 0 &&
            res.data.teamSync.selectedMembers[0]._id
          ) {
            res.data.teamSync.selectedMembersInfo =
              res.data.teamSync.selectedMembers;
            // res.data.teamSync.selectedMembers =
            //   res.data.teamSync.selectedMembers.map((mem) => mem._id);
          }
          dispatch(setUserTeamSync(res.data.teamSync));
          dispatch(updateUserTeamSyncs(res.data.teamSync));

          // res.data.teamSync.projectName=data.projectName;
          // if (
          //   res.data.teamSync.selectedMembers.length > 0 &&
          //   res.data.teamSync.selectedMembers[0]._id
          // ) {
          //   res.data.teamSync.selectedMembers =
          //     res.data.teamSync.selectedMembers.map((mem) => mem._id);
          // }
        }
        return res;
      });
  };
}

export function updateTeamSyncCustomEmoji(wId, tId, data) {
  return (dispatch) => {
    // return axios.put('/api/teamSync/' + id + '/updateCustomEmoji', data)
    return axios
      .put(`/api/w/${wId}/teamSync/` + tId + '/updateCustomEmoji', data)
      .then((res) => {
        if (res.data.success) {
          dispatch(setUserTeamSync(res.data.teamSync));
          dispatch(updateUserTeamSyncs(res.data.teamSync));
        }
        return res;
      })
      .catch((err) => {
        //console.error(err, 'Error');
      });
  };
}

export function changeStandupHoliday(wId, id, data) {
  return (dispatch) => {
    // return axios.post('/api/workspace/' + wId + '/teamSync/' + id + '/holiday', data).then(res => {
    return axios
      .post('/api/w/' + wId + '/teamSync/' + id + '/holiday', data)
      .then((res) => {
        if (res.data.success) {
          if (
            res.data.teamSync.selectedMembers.length > 0 &&
            res.data.teamSync.selectedMembers[0]._id
          ) {
            res.data.teamSync.selectedMembersInfo =
              res.data.teamSync.selectedMembers;
            // res.data.teamSync.selectedMembers =
            //   res.data.teamSync.selectedMembers.map((mem) => mem._id);
          }
          dispatch(setUserTeamSync(res.data.teamSync));
          dispatch(updateUserTeamSyncs(res.data.teamSync));
        }
        return res;
      });
  };
}

export function sendTeamsyncAck(data, wId) {
  return (dispatch) => {
    // return axios.post(`/bot/api/${wId}/sendAck`, data).then(res => {
    return axios
      .post(`/bot/api/w/${wId}/teamSync/sendAck`, data)
      .then((res) => {});
  };
}

export function excecuteTeamSync(wId, tId) {
  return (dispatch) => {
    // return axios.get(`/api/runTeamSyncNow/` + id)
    return axios
      .get(`/api/w/${wId}/teamSync/${tId}/runTeamSyncNow`)
      .then((res) => {
        return res;
      });
  };
}

export function deleteteamsync(wId, tId) {
  return (dispatch) => {
    // return axios.delete(`/api/deleteTeamSync/` + id)
    return axios
      .delete(`/api/w/${wId}/teamSync/${tId}/deleteTeamSync`)

      .then((res) => {
        if (res.data.success) {
          dispatch(deleteUserTeamSync(tId));
        }
        return res;
      });
  };
}
// Jira Server: Connection

// export function addBasicAuth(workspace_id, skill_id, data) {
//   return dispatch => {
//     // return axios.post('/bot/api/workspace/' + workspace_id + '/addBasicAuth/' + skill_id, data).then(res => {
//     return axios.post(`/bot/api/w/${workspace_id}/jira/${skill_id}/addBasicAuth`, data).then(res => {
//       if (res.data.success) {
//         dispatch(setCurrentSkill(res.data.skill))
//       }
//       return res;
//     })
//   }
// }

// Jira Server: Adding User
// export function addUserBasicToken(workspace_id, skill_id, data) {
//   return dispatch => {

//     // return axios.post('/bot/api/workspace/' + workspace_id + '/addUserBasicToken/' + skill_id, data).then(res => {
//     return axios.post('/bot/api/w/' + workspace_id + '/jira/addUserBasicToken/' + skill_id, data).then(res => {
//       if (res.data.success) {
//         dispatch(setCurrentSkillUser(res.data.skillUser));
//       }
//       return res;

//     })
//   }
// }

// to get all users
export function getAllUsers(workspace_id) {
  return (dispatch) => {
    // return axios.get('/bot/slack/getAllUsers/' + workspace_id).then(res => {
    return axios
      .get(`/bot/api/w/${workspace_id}/team/getAllUsers`)
      .then((res) => {
        if (res.data.success) {
          dispatch(AllUsers(res.data.users));
        }
        return res;
      });
  };
}

export function getBotUsers(workspace_id) {
  return (dispatch) => {
    // return axios.get('/bot/slack/getAllUsers/' + workspace_id).then(res => {
    return axios
      .get(`/bot/api/w/${workspace_id}/team/getBotUsers`)
      .then((res) => {
        if (res && res.data && res.data.success) {
          dispatch(setBotUsers(res.data.botUsers));
        }
        return res;
      });
  };
}

export function sendDefaultLauncher(wId, channelId, userId) {
  return (dispatch) => {
    // return axios.get('/bot/api/' + wId + '/sendLauncher/' + userId + '/' + channelId).then(data => {
    return axios
      .get(
        '/bot/api/w/' + wId + '/team/sendLauncher/' + userId + '/' + channelId
      )
      .then((data) => {});
  };
}

export function exportToCsv(wId, data) {
  return (dispatch) => {
    // return axios.post(`/bot/api/${wId}/exportToCsv`, data).then(data => {
    return axios
      .post(`/bot/api/w/${wId}/teamSync/exportToCsv`, data)
      .then((data) => {
        return data;
      });
  };
}

//Get User Activities
export function getJiraUserActivity(wId, user_id, teamsync_id) {
  const queryParams = teamsync_id ? `?tId=${teamsync_id}` : '';
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/getUserActivities/${user_id}`).then(data => {
    return axios
      .get(`/bot/api/w/${wId}/getUserActivities/${user_id}${queryParams}`)
      .then((data) => {
        return data.data;
      });
  };
}

// TO get all workspace members
export function getWorkspaceMembers(wId) {
  // return (dispatch) => {
  //   return axios.get('/api/w/' + wId + '/workspace/membership').then((res) => {
  //     if (res.data.success) {
  //       dispatch(setWorkspaceMembers(res.data.members));
  //     }
  //     return res;
  //   });
  // };
}

export function searchWorkspaceMembers(wId, query, type) {
  return (dispatch) => {
    if (!type) {
      type = '';
    }
    return axios
      .get(
        `/api/w/${wId}/workspace/membership/search?search=${query}&type=${type}`
      )
      .then((res) => {
        if (res.data.success) {
          // dispatch(setWorkspaceMembers(res.data.members));
          // dispatch(setIsAdmin(res.data.members));
        }
        return res;
      });
  };
}

export function searchSlackUsers(wId, query, type) {
  return (dispatch) => {
    if (!type) {
      type = '';
    }
    return axios
      .get(`/bot/api/w/${wId}/team/searchUsers?search=${query}`)
      .then((res) => {
        if (res.data.success) {
          // dispatch(setWorkspaceMembers(res.data.members));
          // dispatch(setIsAdmin(res.data.members));
        }
        return res;
      });
  };
}

// To update user info
// export function updateUserInfo(wId,data) {
//   return dispatch => {
//     // return axios.put('/api/updateUserInfo', data).then(res => {
//     return axios.put(`/api/w/${wId}/workspace/updateUserInfo`, data).then(res => {
//       if (res.data.success) {
//         dispatch(setUser(res.data.user));
//       }
//       return res;
//     });
//   }

// }

// To get user info
// export function getProfileinfo() {
//   return dispatch => {
//     // return axios.get('/api/getProfileinfo').then(res => {
//     return axios.get('/api/user/profileInfo').then(res => {
//       if (res.data.success) {
//         dispatch(setUser(res.data.user));
//       }
//       return res;
//     });
//   }
// }

// export function updateUserWorkspaces(data,wId) {
//   return dispatch => {
//     // return axios.put('/api/'+wId+'/workspace_timezone', data)
//     return axios.put('/api/w/'+wId+'/workspace/workspace_timezone', data)
//       .then(res => {
//         if (res.data.success) {
//         }
//         return res;
//       })
//   }
// }

// export function deleteAccount(wId) {
//   return dispatch => {
//     // return axios.delete('/api/user/deleteAccount')
//     return axios.delete(`/api/w/${wId}/workspace/user/deleteAccount`)
//       .then(res => {
//         if (res.data.success) {
//         }
//         return res;
//       })
//   }
// }

// update workspace
export function updateWorkspace(id, showStatus, data) {
  return (dispatch) => {
    // return axios.put('/api/'+id+'/workspace', data).then(res => {
    return axios.put('/api/w/' + id + '/workspace', data).then((res) => {
      if (res.data.success) {
        res.data.workspace.showStatus = showStatus;
        dispatch(setWorkspace(res.data.workspace));
      }
      return res;
    });
  };
}

// export function setAssistantName(wId, newName) {
//   return dispatch => {
//     // return axios.post(`/bot/api/${wId}/setAssistantName`, {name: newName}).then((res) => {
//     return axios.post(`/bot/api/w/${wId}/team/setAssistantName`, {name: newName}).then((res) => {
//       if (res.data.success) {
//         dispatch(updateAssistantName(newName))
//       }
//       return res;
//     })

//   }
// }

export function getWorkspace(wId) {
  return (dispatch) => {
    // return axios.get('/api/' + id+'/workspace').then(res => {
    return axios
      .get('/api/W/' + wId + '/workspace')
      .then((res) => {
        if (res.data.success) {
          dispatch(setWorkspace(res.data.workspace));
        } else {
          dispatch({ type: 'ERROR', payload: res.data });
        }
        return res;
      })
      .catch((err) => {
        if (err.error !== 'cancel') {
          dispatch({
            type: 'ERROR',
            payload: { message: err.message, type: err.type },
          });
        }
        ////console.error(err);
        return err;
      });
  };
}

// export function leaveWorkspace(workspace_id) {
//   return dispatch => {
//     // return axios.delete('/api/workspace/' + workspace_id + '/leaveWorkspace').then(res => {
//     return axios.delete('/api/w/' + workspace_id + '/workspace/leaveWorkspace').then(res => {

//       if (res.data.success) {
//       }
//       return res;
//     });
//   }
// }

export function removeWorkspaceMember(id) {
  return {
    type: DELETE_WORKSPACE_MEMBER,
    id,
  };
}

// export function deleteWorkspaceMember(wId, id) {
//   return dispatch => {
//     // return axios.delete('/api/' + wId + '/membership/' + id).then(res => {
//     return axios.delete('/api/w/' + wId + '/workspace/membership/' + id).then(res => {
//       if (res.data.success) {
//         dispatch(removeWorkspaceMember(id));
//       }
//       return res;
//     });
//   }
// }

export function updateWorkspaceMembership(membership) {
  return {
    type: UPDATE_WORKSPACE_MEMBERSHIP,
    membership,
  };
}
export function addWorspaceAdmin(membership) {
  return {
    type: 'ADD_WORKSPACE_MEMBERSHIP',
    membership,
  };
}
export function removeWorkspaceAdmin(membership) {
  return {
    type: 'REMOVE_WORKSPACE_MEMBERSHIP',
    membership,
  };
}

export function updateMembership(wId, mId, body) {
  return (dispatch) => {
    // return axios.put("/api/" + id + "/membership/" + mId, body).then(res => {
    return axios
      .put('/api/w/' + wId + '/workspace/membership/' + mId, body)
      .then((res) => {
        if (res.data.success) {
          dispatch(updateWorkspaceMembership(res.data.membership));
        }
        return res;
      });
  };
}

export function makeWorkspaceAdmin(wId, mId) {
  return (dispatch) => {
    // return axios.post(`/api/${wId}/${mId}/addAdmin`).then(res => {
    return axios.post(`/api/w/${wId}/workspace/${mId}/addAdmin`).then((res) => {
      if (res.data.success) {
        dispatch(addWorspaceAdmin(res.data.membership));
      }
      return res;
    });
  };
}

export function deleteWorkspaceAdmin(wId, val) {
  return (dispatch) => {
    // return axios.post(`/api/${id}/${val}/deleteAdmin`).then(res => {
    return axios
      .post(`/api/w/${wId}/workspace/${val}/deleteAdmin`)
      .then((res) => {
        if (res.data.success) {
          dispatch(removeWorkspaceAdmin(res.data.membership));
        }
        return res;
      });
  };
}

// team sync analytics

export const getTeamSyncAnalytics = (wId, teamSyncId, data) => {
  return (dispatch) => {
    // return axios.get(`/api/getTeamSyncAnalytics/${id}`,{
    return axios
      .get(`/api/w/${wId}/teamSync/${teamSyncId}/analytics`, {
        params: {
          selectedMembers: data.selectedMembers,
          startDate: data.startDate,
          endDate: data.endDate,
        },
      })
      .then((res) => {
        if (res.data.success) {
          dispatch(setWorkspaceTeamSyncData(res.data));
        }
        return res;
      });
  };
};

//standup history

export const getStandupHistory = (wId, teamSyncId, data, showMore) => {
  return (dispatch) => {
    // return axios.get(`/api/${wId}/teamSync/${tId}/userResponses`,{params:{
    return axios
      .get(`/api/w/${wId}/teamSync/${teamSyncId}/userResponses`, {
        params: {
          startAt: data.startAt,
          startDate: data.startDate,
          endDate: data.endDate,
          user_id: data.user_id,
          user_slack_id: data.user_slack_id,
        },
      })
      .then((res) => {
        if (res.data.success) {
          if (showMore && showMore == 'true') {
            dispatch(updateStandupHistory(res.data));
          } else {
            dispatch(setStandupHistory(res.data));
          }
        }
        return res;
      });
  };
};

//standup csv

export const getStandupCsvReport = (wId, tId, data) => {
  return (dispatch) => {
    // return axios.get(`/api/${wId}/teamSync/${tId}/getCsvReport`,{params:{
    return axios
      .get(`/api/w/${wId}/teamSync/${tId}/getCsvReport`, {
        params: {
          startAt: data.startAt,
          startDate: data.startDate,
          endDate: data.endDate,
          user_id: data.user_id,
        },
      })
      .then((res) => {
        return res;
      });
  };
};

export const sendReportEmail = (wId, tId, data) => {
  return (dispatch) => {
    // return axios.post(`/api/${wId}/teamSync/${tId}/sendTeamsyncReportAsEmail`,{
    return axios
      .post(`/api/w/${wId}/teamSync/${tId}/sendTeamsyncReportAsEmail`, {
        startDate: data.startDate,
        endDate: data.endDate,
        user_id: data.user_id,
        exactStartDate: data.exactStartDate,
        exactEndDate: data.exactStartDate,
      })
      .then((res) => {
        return res;
      });
  };
};

export const createTeamSync = (wId, data) => {
  return (dispatch) => {
    // return axios.post(`/api/createNewTeamSync/${wId}`,data).then(res => {
    return axios.post(`/api/w/${wId}/createNewTeamSync`, data).then((res) => {
      if (res.data.success) {
        dispatch(setUserTeamSync(res.data.teamSync));
        dispatch(updateUserTeamSyncsList(res.data.teamSync));
      }
      return res;
    });
  };
};

export function updateProgressReport(data) {
  return {
    type: 'update_progress_report',
    data,
  };
}

export function updateUserLeave(data) {
  return {
    type: 'update_user_holiday',
    data,
  };
}

export function UpdateStandupReport(data) {
  return {
    type: UPDATE_TEAMSYNC_INSTANCE_REPORT,
    report: data,
  };
}

export function UpdateLikesAndComments(data) {
  return {
    type: 'update_likes_and_comments',
    data: data,
  };
}
export function UpdateLikesForCard(data) {
  return {
    type: 'update_likes_for_card',
    data: data,
  };
}
export function UpdateCommentsForCard(data) {
  return {
    type: 'update_comments_for_card',
    data: data,
  };
}

export function setCommonChannelData(data) {
  return {
    type: 'set_common_channel_data',
    data,
  };
}
export function updateCommonChannelData(data) {
  return {
    type: 'update_common_channel_data',
    data,
  };
}
export function DeleteConfluenceChannelConfig(id) {
  return {
    type: REMOVE_CONFLUENCE_CHANNEL_CONFIG,
    id,
  };
}
export function addChannel(channel) {
  return {
    type: ADD_CHANNEL,
    channel,
  };
}

export function RecentReminders(reminders) {
  return {
    type: RECENT_REMINDERS,
    reminders,
  };
}

export function addActionItem(wId, data) {
  return (dispatch) => {
    return (
      axios
        // .post(`/api/${data.teamsync_id}/${data.teamsync_instance_id}/addActionItem`,data)
        .post(
          `/api/w/${wId}/teamSync/${data.teamsync_id}/instance/${data.teamsync_instance_id}/addActionItem`,
          data
        )
        .then((res) => {
          if (res.data.success) {
            dispatch(UpdateStandupReport(res.data.report));
          }
          return res;
        })
        .catch((err) => {
          ////console.error(err);
        })
    );
  };
}

export function deleteActionItem(wId, teamsyncId, actionItemId) {
  return (dispatch) => {
    return (
      axios
        // .delete(`/api/${actionItemId}/deleteActionItem`)
        .delete(
          `/api/w/${wId}/teamSync/${teamsyncId}/deleteActionItem/${actionItemId}`
        )
        .then((res) => {
          if (res.data.success) {
            dispatch(UpdateStandupReport(res.data.report));
          }
          return res;
        })
        .catch((err) => {
          ////console.error(err);
        })
    );
  };
}

export const createGrouping = (wId, teamSyncId, instanceId, data) => {
  return (dispatch) => {
    return (
      axios
        // .post(`/api/teamSync/${instanceId}/createGrouping`, data)
        .post(
          `/api/w/${wId}/teamSync/${teamSyncId}/instacne/${instanceId}/createGrouping`,
          data
        )
        .then((res) => {
          if (res.data.success) {
            dispatch(UpdateStandupReport(res.data.report));
          }
          return res;
        })
        .catch((err) => {
          ////console.error(err);
        })
    );
  };
};

export const removeGroupingForDuplicate = (
  wId,
  teamSyncId,
  instanceId,
  data
) => {
  return (dispatch) => {
    return (
      axios
        // .post(`/api/teamSync/${instanceId}/removeGroupingForDuplicate`,data)
        .post(
          `/api/w/${wId}/teamSync/${teamSyncId}/instacne/${instanceId}/removeGroupingForDuplicate`,
          data
        )
        .then((res) => {
          if (res.data.success) {
            dispatch(UpdateStandupReport(res.data.report));
          }
          return res;
        })
        .catch((err) => {
          ////console.error(err);
        })
    );
  };
};

export const removeGroupingForMaster = (wId, teamSyncId, instanceId, data) => {
  return (dispatch) => {
    return (
      axios
        // .post(`/api/teamSync/${instanceId}/removeGroupingForMaster`, data)
        .post(
          `/api/w/${wId}/teamSync/${teamSyncId}/instacne/${instanceId}/removeGroupingForMaster`,
          data
        )
        .then((res) => {
          if (res.data.success) {
            dispatch(UpdateStandupReport(res.data.report));
          }
          return res;
        })
        .catch((err) => {
          ////console.error(err);
        })
    );
  };
};

export const answerTeamSync = (wId, teamSyncId, instanceId, data) => {
  return (dispatch) => {
    return (
      axios
        // .post(`/api/teamSync/${instanceId}/progressReport`, data)
        .post(
          `/api/w/${wId}/teamSync/${teamSyncId}/answer/${instanceId}/progressReport`,
          data
        )
        .then((res) => {
          if (res.data.success) {
            dispatch(updateProgressReport(res.data.progressReport));
          }
          return res;
        })
    );
  };
};

export const addNextAnswerTeamsync = (wId, tid, data) => {
  return (dispatch) => {
    return (
      axios
        // .post(`/api/${wId}/teamsync/${tid}/earlyresponse`, data)
        .post(`/api/w/${wId}/teamSync/${tid}/earlyresponse`, data)
        .then((res) => {
          return res.data;
        })
    );
  };
};

export const getEarlyNextTeamsyncAnswer = (wId, tid) => {
  return (dispatch) => {
    return (
      axios
        // .get(`/api/${wId}/teamsync/${tid}/earlyresponse`)
        .get(`/api/w/${wId}/teamSync/${tid}/earlyresponse`)
        .then((res) => {
          return res.data;
        })
    );
  };
};

export const updateUserHoliday = (wId, teamSyncId, data) => {
  return (dispatch) => {
    return (
      axios
        // .put(`/api/teamSync/markOnLeave`, data)
        .put(`/api/w/${wId}/teamSync/${teamSyncId}/markOnLeave`, data)
        .then((res) => {
          if (res.data.success) {
            if (res.data.updatedTeamSyncResponses) {
              res.data.updatedTeamSyncResponses.forEach((val) => {
                dispatch(updateUserLeave(val));
              });
            }
          }
          return res;
        })
        .catch((err) => {
          //console.error(err, 'Error');
        })
    );
  };
};

export function insertWorkspaceMembers(member) {
  return {
    type: ADD_WORKSPACE_MEMBER,
    member,
  };
}

// export function sendWorkspaceInvite(id, wsName, email) {
//   return dispatch => {
//     return axios.post('/api/' + id + '/workspace_invite', { email: email, name: wsName })
//     .then(res => {
//       if (res.data.success) {
//         if (res.data.member) {
//           dispatch(insertWorkspaceMembers(res.data.member));
//         }
//         // else {
//         //   dispatch(insertWorkspaceInvite(res.data.invite));
//         // }
//       }
//       return res;
//     });
//   }
// }

export const getJiraProjectStatues = (wId, skillId, id) => {
  return (dispatch) => {
    // return axios.get(`/bot/jira/${skillId}/${id}/statuses`)
    return axios
      .get(`/bot/api/w/${wId}/jira/${skillId}/${id}/statuses`)
      .then((res) => {
        if (res.data.success) {
          dispatch(getJiraStatuses(res.data.statuses));
        }
        return res;
      });
  };
};

export const getJiraIssuePicker = (wId, query) => {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/getJiraIssuePicker?query=${query}`)
    return axios
      .get(`/bot/api/w/${wId}/jira/getJiraIssuePicker?query=${query}`)
      .then((res) => {
        return res;
      });
  };
};
export const getJiraIssueLinkBlocks = (wId) => {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/getJiraIssueLinkBlocks`)
    return axios
      .get(`/bot/api/w/${wId}/jira/getJiraIssueLinkBlocks`)
      .then((res) => {
        return res;
      });
  };
};

export const getTaskAssignableUsers = (wId, params) => {
  // return axios.get(`/bot/api/${wId}/getTaskAssignableUsers`,params).then(res => res)
  return axios
    .get(`/bot/api/w/${wId}/jira/getTaskAssignableUsers`, params)
    .then((res) => res);
};

export const getDateDuckling = (wId, text, tz) => {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/getDateDuckling`,{params:{
    return axios
      .get(`/bot/api/w/${wId}/teamSync/getDateDuckling`, {
        params: {
          text,
          tz,
        },
      })
      .then((res) => {
        return res;
      });
  };
};

export const getOAuthAccessTokensForUsers = (
  wId,
  oauth_verifier,
  sessionid
) => {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/getOAuthAccessTokensForUsers?oauth_verifier=${oauth_verifier}&sessionid=${sessionid}`).then(res => {
    return axios
      .get(
        `/bot/api/w/${wId}/jira/getOAuthAccessTokensForUsers?oauth_verifier=${oauth_verifier}&sessionid=${sessionid}`
      )
      .then((res) => {
        if (res.data.success) {
          dispatch(setCurrentSkillUser(res.data.skillUser));
        }
        return res;
      });
  };
};
export const getGuestOAuthAccessTokensForUsers = (
  wId,
  oauth_verifier,
  sessionid
) => {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/guest/getOAuthAccessTokensForUsers?oauth_verifier=${oauth_verifier}&sessionid=${sessionid}`).then(res => {
    return axios
      .get(
        `/bot/api/w/${wId}/jira/guest/getOAuthAccessTokensForUsers?oauth_verifier=${oauth_verifier}&sessionid=${sessionid}`
      )
      .then((res) => {
        if (res.data.success) {
        }
        return res;
      });
  };
};

export const updateAdminToken = (wId, oauth_verifier, sessionid) => {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/updateAdminToken?oauth_verifier=${oauth_verifier}&sessionid=${sessionid}`).then(res => {
    return axios
      .get(
        `/bot/api/w/${wId}/jira/updateAdminToken?oauth_verifier=${oauth_verifier}&sessionid=${sessionid}`
      )
      .then((res) => {
        if (res.data.success) {
        }
        return res;
      });
  };
};

export const getAccessTokens = (wId, oauth_verifier, sessionid) => {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/generateOAuthAccessTokens?oauth_verifier=${oauth_verifier}&sessionid=${sessionid}`).then(res=>{
    return axios
      .get(
        `/bot/api/w/${wId}/jira/generateOAuthAccessTokens?oauth_verifier=${oauth_verifier}&sessionid=${sessionid}`
      )
      .then((res) => {
        if (res.data.success) {
          dispatch(setCurrentSkill(res.data.skill));
          res.data.skill.name === 'Jira' &&
            dispatch(updateAssisantSkills(res.data.skill));
        }
        return res;
      });
  };
};

export const updateChannelCommonData = (data, wId) => (dispatch, getStore) => {
  // return axios.post(`/bot/api/workspace/${wId}/updateChannelCommonData`,data).then(res => {
  return axios
    .post(`/bot/api/w/${wId}/updateChannelCommonData`, data)
    .then((res) => {
      const commonData = getStore().skills.commonChanneldata;
      if (res.data.success) commonData.push(res.data.newChannelCommonData);
      dispatch(setCommonChannelData(commonData));
      return res.data;
    });
};

// export const getAccessTokens=(wId,oauth_verifier,sessionid)=>{
//   return dispatch =>{
//     return axios.get(`/bot/api/${wId}/generateOAuthAccessTokens?oauth_verifier=${oauth_verifier}&sessionid=${sessionid}`).then(res=>{
// if(res.data.success){
//   dispatch(setCurrentSkill(res.data.skill));
// }
// return res
//     })

//   }

// }

// export const addLikeToStandupVer2 = (data) => {
//   if (data) data.showPreviousReport = true;
//   return dispatch => {
//     // return axios.put(`/api/${data.workspace_id}/${data.reportid}/addCommentsAndVotes?type=${data.type}`, data).then(res => {
//     return axios.put(`/api/w/${data.workspace_id}/teamSync/${data.tId}/${data.reportid}/addCommentsAndVotes?type=${data.type}`, data).then(res => {
//       if (res.data.success) {
//         dispatch(UpdateLikesAndComments(res.data.report))
//       }
//       return res
//     })
//   }
// }
export const addLikeToStandupVer3 = (data) => {
  if (data) data.showPreviousReport = true;
  return (dispatch) => {
    // return axios.put(`/api/${data.workspace_id}/checkin_response/${data.reportid}/response_likes`).then(res => {
    return axios
      .put(
        `/api/w/${data.workspace_id}/teamSync/${data.teamSyncId}/answer/${data.reportid}/response_likes`
      )
      .then((res) => {
        if (res.data.success) {
          dispatch(UpdateLikesForCard(res.data.progressReport));
        }
        return res;
      });
  };
};
//please vote for modi
export const addLikeToStandup = (data) => {
  if (data) data.showPreviousReport = true;
  return (dispatch) => {
    // return axios.put(`/api/${data.workspace_id}/${data.reportid}/addCommentsAndVotes?type=${data.type}`,data).then(res=>{
    return axios
      .put(
        `/api/w/${data.workspace_id}/teamSync/${data.teamSyncId}/answer/${data.reportid}/addCommentsAndVotes?type=${data.type}`,
        data
      )
      .then((res) => {
        if (res.data.success) {
          dispatch(UpdateStandupReport(res.data.report));
        }
        return res;
      });
  };
};
// /api/:wId/checkin_response/:id/comment
export const deleteRetroComment = (wId, teamSyncId, commentId) => {
  return (dispatch) => {
    // return axios.delete(`/api/${commentId}/progressComment`).then(res => {
    return axios
      .delete(
        `/api/w/${wId}/teamSync/${teamSyncId}/${commentId}/progressComment`
      )
      .then((res) => {
        if (res.data.success) {
          dispatch(UpdateStandupReport(res.data.report));
        }
        return res;
      });
  };
};
export const addRetroComment = (wId, teamSyncId, data) => {
  return (dispatch) => {
    // return axios.post(`/api/${data.reportid}/progressComment`, data).then(res => {
    return axios
      .post(
        `/api/w/${wId}/teamSync/${teamSyncId}/${data.reportid}/progressComment`,
        data
      )
      .then((res) => {
        if (res.data.success) {
          dispatch(UpdateCommentsForCard(res.data.progressReport));
        }
        return res;
      });
  };
};

export const channelAdminConfig = (
  wId,
  skillId,
  channelId,
  data,
  isGridSharedChannel
) => {
  // let link = `/bot/api/${wId}/channelAdminsConfig/${skillId}/channel/${channelId}`
  let link = `/bot/api/w/${wId}/channelConfig/channelAdminsConfig/${skillId}/channel/${channelId}`;
  if (isGridSharedChannel) link += '?isGridSharedChannel=true';
  return (dispatch) => {
    return axios.post(link, data).then((res) => {
      if (res.data.success) {
        if (res.data.channelCommonData)
          dispatch(updateCommonChannelData(res.data.channelCommonData));
      }
      return res;
    });
  };
};

export async function getJiraCommonConfig(wId, sId, cId) {
  let response = await axios.get(
    `/bot/api/w/${wId}/jira/${sId}/${cId}/getJiraChannelCommonConfig`
  );
  return response;
}

export const updateCommonChannelDataApi = (
  wId,
  skill_id,
  channelId,
  data,
  config_id
) => {
  // let link = `/bot/api/${wId}/channelAdminsConfig/${skillId}/channel/${channelId}`
  // '/api/w/:wId/skill/:skill_id/config/:config_id'
  let link = `/bot/api/w/${wId}/skill/${skill_id}/config/${config_id}?channel=${channelId}`;
  // if (isGridSharedChannel) link += '?isGridSharedChannel=true';
  return (dispatch) => {
    return axios.post(link, data).then((res) => {
      if (res.data.success) {
        if (res.data.updatedConfig)
          dispatch(updateCommonChannelData(res.data.updatedConfig));
      }
      return res;
    });
  };
};

// export const userChannelNotifications=(wId,skillId, isGridWorkspace)=>{
//   // let link = '/bot/api/userChannelNotifications/'+wId+'/'+skillId
//   let link = `/bot/api/w/${wId}/userChannelNotifications/${skillId}`
//   if(isGridWorkspace) link += '?isGridWorkspace=true'

//   return dispatch =>{
//     return axios.get(link).then(res=>{
//       if(res.data.success){
//         dispatch(setCommonChannelData(res.data.commonData));
//       }
//       return res
//     })
//   }
// }

export function enableAndDisableNotificationSubscription(
  wId,
  data,
  subscriptionid,
  isGridSharedChannel
) {
  // let link =`/bot/api/${wId}/subscription/${subscriptionid}`
  let link = `/bot/api/w/${wId}/channelConfig/subscription/${subscriptionid}`;
  if (isGridSharedChannel) link += '?isGridSharedChannel=true';
  return (dispatch) => {
    return axios.put(link, data).then((res) => {
      if (res.data.success) {
      }
      return res;
    });
  };
}

export function getConfluenceSpaces(wId) {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/wiki/spaces`).then(res => {
    return axios.get(`/bot/api/w/${wId}/wiki/spaces`).then((res) => {
      if (res.data.success) {
        dispatch(setConfluenceSpaces(res.data.spaces));
      }
      return res;
    });
  };
}
export function getConfluenceChannelConfig(wId, cId) {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/wiki/channelConfig/${cId}`).then(res => {
    return axios
      .get(`/bot/api/w/${wId}/wiki/channelConfig/${cId}`)
      .then((res) => {
        if (res.data.success) {
          dispatch(setConfluenceChannelConfig(res.data.config));
        }
        return res;
      });
  };
}
export function addConfluenceChannelConfig(wId, data, addNewOne) {
  return (dispatch) => {
    // return axios.post(`/bot/api/${wId}/wiki/channelConfig`,data).then(res => {
    return axios
      .post(`/bot/api/w/${wId}/wiki/channelConfig`, data)
      .then((res) => {
        if (res.data.success) {
          dispatch(setConfluenceChannelConfig(res.data.config));
          if (addNewOne === true && res.data.success) {
            dispatch(addConfluenceChannelConfigtoStore(res.data.config));
          }
        }
        return res;
      });
  };
}

export function getConfluenceChannelConfigs(wId, sendAll, getCount) {
  return (dispatch) => {
    let query = '';
    if (sendAll) {
      query = `showAll=true`;
    }

    if (getCount) query += `&getCount=true`;
    // return axios.get(`/bot/api/${wId}/wiki/configPicker?${query}`).then(res => {
    return axios
      .get(`/bot/api/w/${wId}/wiki/configPicker?${query}`)
      .then((res) => {
        if (res.data.success) {
          if (!getCount)
            dispatch(setConfluenceChannelConfigList(res.data.configs));
        }
        return res;
      });
  };
}

export function deleteConfluenceChannelConfig(
  wId,
  id,
  skill_id,
  isGridSharedChannel
) {
  return async (dispatch) => {
    try {
      const query = isGridSharedChannel
        ? `?isGridSharedChannel=${isGridSharedChannel}`
        : '';
      // const deletedinfo = await axios.post(`/bot/api/workspace/${wId}/wiki/${skill_id}/deleteconfluenceconfig/${id}${query}`)
      const deletedinfo = await axios.post(
        `/bot/api/w/${wId}/wiki/${skill_id}/deleteconfluenceconfig/${id}${query}`
      );
      dispatch(DeleteConfluenceChannelConfig(id));
      return deletedinfo;
    } catch (err) {
      return null;
    }
  };
}

export function createNewChannel(wId, name, type) {
  return async (dispatch) => {
    try {
      let obj = { name };
      if (type) obj.type = type;
      // const res=await axios.post(`/bot/api/workspace/${wId}/createChannel`,obj)
      const res = await axios.post(
        `/bot/api/w/${wId}/slack/createChannel`,
        obj
      );
      if (res.data && res.data.success) {
        if (res.data && res.data.channel && res.data.channel.id) {
          dispatch(addChannel(res.data.channel));
        }
        return res.data;
      }
      return res.data;
    } catch (err) {
      return null;
    }
  };
}

export const sendUserMappingReminder = (wId, reminderSendId, data) => {
  return (dispatch) => {
    // return axios.post(`/bot/api/${wId}/${reminderSendId}/sendUserMappingReminder`,data).then(res => {
    return axios
      .post(
        `/bot/api/w/${wId}/jira/${reminderSendId}/sendUserMappingReminder`,
        data
      )
      .then((res) => {
        return res.data;
      });
  };
};

export const getChannelMembersofSlack = (wId, channelId) => {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/${channelId}/getChannelMembers`).then(res => {
    return axios
      .get(`/bot/api/w/${wId}/slack/${channelId}/getChannelMembers`)
      .then((res) => {
        return res.data;
      });
  };
};

export const getRecentRemindersToUsers = (wId, type) => {
  return (dispatch) => {
    // return axios.get(`/bot/api/${wId}/${type}/getRecentReminders`).then(res => {
    return axios
      .get(`/bot/api/w/${wId}/${type}/getRecentReminders`)
      .then((res) => {
        if (res.data && res.data.success) {
          dispatch(RecentReminders(res.data.reminders));
        }
      });
  };
};

export const checkChannelConfigs = (wId, data) => {
  // return axios.post(`/bot/api/${wId}/checkChannelConfigs`,data).then(res => res.data)
  return axios
    .post(`/bot/api/w/${wId}/channelConfig/checkChannelConfigs`, data)
    .then((res) => res.data);
};

export const dropDownSearchJiraProjects = (wId, query) => {
  return (dispatch) => {
    // return axios.get(`/bot/jira/${id}/searchJiraProject${query || ''}`)
    return axios
      .get(`/bot/api/w/${wId}/jira/searchJiraProject${query || ''}`)
      .then((res) => {
        if (
          res.data.success &&
          res.data.projectsData &&
          res.data.projectsData.values
        ) {
          dispatch(addJiraProjectsFromDropdown(res.data.projectsData.values));
        }

        return res;
      });
  };
};

export const addGlobalGuestToken = (wId, skill_id) => {
  return (dispatch) => {
    // return axios.post(`/bot/api/${wId}/${skill_id}/addGlobalGuestToken`, {}).then(res => {
    return axios
      .post(`/bot/api/w/${wId}/jira/${skill_id}/addGlobalGuestToken`, {})
      .then((res) => {
        if (res.data.success) {
          dispatch(updateAssisantSkills(res.data.skill));
        }
        return res.data;
      });
  };
};

export const getEmojiActions = (wId) => {
  // return axios.get(`/bot/api/${wId}/emoji_actions`).then(res => res.data)
  return axios
    .get(`/bot/api/w/${wId}/workspace/emoji_actions`)
    .then((res) => res.data);
};

export const createEmojiAction = (wId, data) => {
  // return axios.post(`/bot/api/${wId}/emoji_actions`, data).then(res => res.data)
  return axios
    .post(`/bot/api/w/${wId}/workspace/emoji_actions`, data)
    .then((res) => res.data);
};

export const updateEmojiAction = (wId, id, data) => {
  // return axios.put(`/bot/api/${wId}/emoji_action/${id}`, data).then(res => res.data)
  return axios
    .put(`/bot/api/w/${wId}/workspace/emoji_action/${id}`, data)
    .then((res) => res.data);
};

export const deleteEmojiAction = (wId, id) => {
  // return axios.delete(`/bot/api/${wId}/emoji_action/${id}`).then(res => res.data)
  return axios
    .delete(`/bot/api/w/${wId}/workspace/emoji_action/${id}`)
    .then((res) => res.data);
};

export const getAllLabelsInTheDomain = (wId, searchQuery = '') => {
  // return axios.get(`/bot/api/${wId}/getAllLabelsInTheDomain`).then(res => res.data)
  let url = `/bot/api/w/${wId}/jira/getAllLabelsInTheDomain`;
  if (searchQuery) url += `?searchQuery=${searchQuery}`;
  return axios.get(url).then((res) => res.data);
};

export const getAllResolutionsInTheDomain = (wId) => {
  // return axios.get(`/bot/api/${wId}/getAllResolutionsInTheDomain`).then(res => res.data)
  return axios
    .get(`/bot/api/w/${wId}/jira/getAllResolutionsInTheDomain`)
    .then((res) => res.data);
};

export const getAllUsersInTheDomain = (wId) => {
  // return axios.get(`/bot/api/${wId}/getAllUsersInTheDomain`).then(res => res.data)
  return axios
    .get(`/bot/api/w/${wId}/jira/getAllUsersInTheDomain`)
    .then((res) => res.data);
};

// export const getAllProjects = async (wId) => {
//   //  return axios.get(`/bot/jira/${wId}/project`).then(res=> res.data.projects)
//    return axios.get(`/bot/api/w/${wId}/jira/project`).then(res=> res.data.projects)
//   }
export const updateCommandapi = async (wId, key, data) => {
  //  return axios.put(`/bot/api/${wId}/commands/${key}`, data).then(res=> res.data.updated)
  return axios
    .put(`/bot/api/w/${wId}/workspace/commands/${key}`, data)
    .then((res) => res.data.updated);
};
export const getAllStatusesInTheDomain = (wId) => {
  // return axios.get(`/bot/api/${wId}/getAllStatusesInTheDomain`).then(res => res.data)
  return axios
    .get(`/bot/api/w/${wId}/jira/getAllStatusesInTheDomain`)
    .then((res) => res.data);
};

export const getIssueFields = (wId) => {
  // return axios.get(`/bot/api/${wId}/getIssueFields`).then(res=>res)
  return axios.get(`/bot/api/w/${wId}/jira/getIssueFields`).then((res) => res);
};
// export const getProjectUsingId= (wId, projectId)=>{
//   return axios.get(`/bot/api/${wId}/getIssueFields/project/${projectId}`).then(res=>res)
// }
export const getFilterFromJira = (wId, id) => {
  // return axios.get(`/bot/api/${wId}/getJiraFilter`).then(res=>res)
  return axios.get(`/bot/api/w/${wId}/jira/getJiraFilter`).then((res) => res);
};

export const getIssueNumberFields = (wId, skillId, templateId) => {
  return (
    axios
      // .get(`/bot/skill/${skillId}/getAllFields/user/${templateId}`, {
      .get(
        `/bot/api/w/${wId}/skill/${skillId}/getAllFields/user/${templateId}`,
        {
          params: {},
        }
      )
      .then((res) => {
        // console.log(JSON.stringify(res.data.items.projects[0].issuetypes[0].fields))
        if (res.data.success) {
          let values = Object.values(res.data.items);
          values = values.filter(
            (field) => field.schema && field.schema.type === 'number'
          );
          this.setState({ numberFields: values });
        }
      })
      .catch((error) => {})
  );
};

export const getAppHomeConfigrations = (config) => {
  return {
    type: APP_HOME_CONFIG,
    data: config,
  };
};

export const getAppHomeConfig = (wId) => {
  // return async dispatch => {
  // axios.get(`/bot/api/${wId}/getAppHome`).then(res => {
  return axios.get(`/bot/api/w/${wId}/webAppHome/user/appHome`).then((res) => {
    if (res && res.data.success) {
      // dispatch(getAppHomeConfigrations(res.data.data))
      // return res
    }
    // console.log('get app Home , ', res)
    return res;
  });
  // }
};
export const addAppHomeConfig = (wId, data) => {
  return axios
    .post(`/bot/api/w/${wId}/webAppHome/addAppHome`, data)
    .then((res) => res);
};
// balaji return axios.post(`/bot/api/w/${wId}/user/appHome`, data).then(res => res)}

export const updateAppHomeConfig = (wId, id, data) => {
  // return async dispatch => {
  // console.log("update app home wid , id, data,", wId, id, data)
  return axios
    .put(`/bot/api/w/${wId}/webAppHome/updateAppHome/${id}`, data)
    .then((res) => {
      // balaji axios.put(`/bot/api/w/${wId}/user/appHome/${id}`, data).then(res => {
      if (res && res.data.success) {
        // console.log(res.data.updated)

        return res.data.updated;
      }
    });
};

export const getWorkspaceChannelSync = (wId, type) => {
  return (
    axios
      // .get(`/bot/api/w/${wId}/jira/${sub_skill}/channel_sync`)
      .get(`/bot/api/w/${wId}/jira/channel_sync?type=${type}`)
      .then((res) => res)
  );
};

export const getWorkspaceAutoChannelSync = (wId, sub_skill) => {
  return axios
    .get(`/bot/api/w/${wId}/jira/${sub_skill}/auto_channel_sync`)
    .then((res) => res);
};

export const deleteChannelSync = (wId, channel_sync_id) => {
  return axios
    .delete(`/bot/api/w/${wId}/jira/channel_sync/${channel_sync_id}`)
    .then((res) => res);
};

export const deleteAutoChannelSync = (wId, auto_channel_sync_id) => {
  return axios
    .delete(`/bot/api/w/${wId}/jira/auto_channel_sync/${auto_channel_sync_id}`)
    .then((res) => res);
};

export const updateChannelSync = (wId, channel_sync_id, data) => {
  return axios
    .put(`/bot/api/w/${wId}/jira/channel_sync/${channel_sync_id}`, data)
    .then((res) => res);
};

export const getProjectIssueFields = (
  wId,
  skill_id,
  project_id,
  user_id,
  issueTypeId
) => {
  return axios.get(
    `/bot/api/w/${wId}/jira/${skill_id}/user/${user_id}/issueFieldsOfProject`,
    {
      params: {
        project_id,
        issueTypeName: issueTypeId,
      },
    }
  );
};

export const verifyJql = (wId, jql) => {
  return axios.post(`/bot/api/w/${wId}/jira/verifyJql/`, {
    jql,
  });
};

export const createAutoChannelSync = (wId, data) => {
  return axios
    .post(`/bot/api/w/${wId}/jira/auto_channel_sync`, data)
    .then((res) => res);
};

export const upadteAutoChannelSync = (wId, autoChannelSync_id, data) => {
  return axios
    .put(`/bot/api/w/${wId}/jira/auto_channel_sync/${autoChannelSync_id}`, data)
    .then((res) => res);
};

export const updateUserOnboarding = ({ wId, user_id, data }) => {
  return axios
    .post(`/bot/api/w/${wId}/user/${user_id}/userOnboarding`, data)
    .then((res) => res);
};

export const getUserOnboarding = ({ wId, user_id }) => {
  return axios
    .get(`/bot/api/w/${wId}/user/${user_id}/userOnboarding`)
    .then((res) => res);
};

export function getWorkspaceAdmins(wId) {
  return (dispatch) => {
    // return axios.get(`/api/${wId}/getWorkspaceMembership`).then(res => {
    return axios.get(`/api/${wId}/admins`).then((res) => {
      if (res.data.success) {
        dispatch(setWorkspaceAdmin(res.data.admins));
      }
      return res;
    });
  };
}

export const copyChannelConfigurations =
  (wId, data, type) => (dispatch, getStore) => {
    // return axios.post(`/bot/api/workspace/${wId}/deleteChannelConfigurations`,data).then(res => {
    return axios
      .post(`/bot/api/w/${wId}/channelConfig/copy`, data)
      .then((res) => {
        if (res && res.data && res.data.success) {
        }
        return res.data;
      });
  };

export const getCustomEmojis = (wId) => {
  return axios
    .get(`/bot/api/w/${wId}/slack/getCustomEmojis`)
    .then((res) => res && res.data && res.data.emojis);
};

// app.get("/api/:wId/webAppHome/getAppHome",  AppHome.getAppHomeConfig)
//   app.post("/api/:wId/webAppHome/getAppHome",  AppHome.addAppHomeConfig)
//   app.put("/api/:wId/webAppHome/getAppHome/:_id",  AppHome.updateAppHomeConfig)
// export function createNewChannel(wId,name,type) {
//   return async dispatch => {
//     try {
//       let obj = {name}
//       if(type) obj.type = type
//       const res=await axios.post(`/bot/api/workspace/${wId}/createChannel`,obj)
//       if (res.data && res.data.success) {
//         if (res.data && res.data.channel && res.data.channel.id) {
//           dispatch(addChannel(res.data.channel));
//         }
//         return res.data

//  }

export function getWorkspaceMemberDetails(wId, data) {
  return () => {
    return axios
      .post(`/api/w/${wId}/workspace/membershipDetails`, data)
      .then((res) => {
        return res;
      });
  };
}

export function getAllWorkspacesFromGrid(wId, id, domainUrl) {
  return axios
    .get(
      `/bot/api/w/${wId}/enterprise/${id}/getAllWorkspacesFromGrid?domainUrl=${domainUrl}`
    )
    .then((res) => res.data);
}
